/* tslint:disable */
import { GraphQLResolveInfo, GraphQLScalarType } from 'graphql';
/**
 * This file is auto-generated by graphql-schema-typescript
 * Please note that any changes in this file may be overwritten
 */
 

/*******************************
 *                             *
 *          TYPE DEFS          *
 *                             *
 *******************************/
export interface GQLRootQuery {
  destinations: GQLDestinations;
  areas: GQLAreas;
  boards: GQLBoards;
  currencies: GQLCurrencies;
  tags: GQLTags;
  activities: GQLActivities;
  beaches: GQLBeaches;
  hotelTypes: GQLHotelTypes;
  events: GQLEvents;
  hotels: GQLHotels;
  elixirServices: GQLElixirServices;
  elixirBeaches: GQLElixirBeaches;
  elixirHotels: GQLElixirHotels;
  juniperHotels: GQLJuniperHotels;
  newsletters: GQLNewsletters;
  references: GQLReferences;
  routes: GQLRoutes;
  packages: GQLPackages;
  settings: GQLSettings;
  search: GQLSearch;
  users: GQLUsers;
}

/**
 * ### Destinations
 */
export interface GQLDestinations {
  
  /**
   * List of destinations
   */
  list: GQLDestinationConnection;
  
  /**
   * Get single destination by its id
   */
  get?: GQLDestination;
  
  /**
   * Get single destination by its slug
   */
  getBySlug?: GQLDestination;
  
  /**
   * Returns list of destination in menu
   */
  inMenu: Array<GQLDestination>;
}

export interface GQLDestinationSelector {
  onlyWithListImage?: boolean;
  onlyWithFeaturedImage?: boolean;
}

/**
 * ### Record visibility filter enum
 */
export enum GQLVisibility {
  ALL = 'ALL',
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  REVIEW = 'REVIEW',
  FORBIDDEN = 'FORBIDDEN'
}

/**
 * ### Return type for destination query
 */
export interface GQLDestinationConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLDestinationEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

export interface GQLConnection {
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/** Use this to resolve interface type Connection */
export type GQLPossibleConnectionTypeNames =
'DestinationConnection' |
'AreaConnection' |
'BeachConnection' |
'HotelConnection' |
'PackageConnection' |
'ActivityConnection' |
'EventConnection' |
'SearchVacancyConnection' |
'SearchHotelConnection';

export interface GQLConnectionNameMap {
  Connection: GQLConnection;
  DestinationConnection: GQLDestinationConnection;
  AreaConnection: GQLAreaConnection;
  BeachConnection: GQLBeachConnection;
  HotelConnection: GQLHotelConnection;
  PackageConnection: GQLPackageConnection;
  ActivityConnection: GQLActivityConnection;
  EventConnection: GQLEventConnection;
  SearchVacancyConnection: GQLSearchVacancyConnection;
  SearchHotelConnection: GQLSearchHotelConnection;
}

/**
 * Information about pagination in a connection.
 */
export interface GQLPageInfo {
  
  /**
   * When paginating forwards, are there more items?
   */
  hasNextPage: boolean;
  
  /**
   * When paginating backwards, are there more items?
   */
  hasPreviousPage: boolean;
  
  /**
   * When paginating backwards, the cursor to continue.
   */
  startCursor?: string;
  
  /**
   * When paginating forwards, the cursor to continue.
   */
  endCursor?: string;
}

/**
 * ### Destination edge definition
 */
export interface GQLDestinationEdge extends GQLEdge {
  
  /**
   * Node with destination data
   */
  node: GQLDestination;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * Edge interface
 */
export interface GQLEdge {
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/** Use this to resolve interface type Edge */
export type GQLPossibleEdgeTypeNames =
'DestinationEdge' |
'AreaEdge' |
'BeachEdge' |
'HotelEdge' |
'PackageEdge' |
'ActivityEdge' |
'EventEdge' |
'SearchVacancyEdge' |
'SearchHotelEdge';

export interface GQLEdgeNameMap {
  Edge: GQLEdge;
  DestinationEdge: GQLDestinationEdge;
  AreaEdge: GQLAreaEdge;
  BeachEdge: GQLBeachEdge;
  HotelEdge: GQLHotelEdge;
  PackageEdge: GQLPackageEdge;
  ActivityEdge: GQLActivityEdge;
  EventEdge: GQLEventEdge;
  SearchVacancyEdge: GQLSearchVacancyEdge;
  SearchHotelEdge: GQLSearchHotelEdge;
}

/**
 * ### Destination entity
 */
export interface GQLDestination extends GQLNode {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Destination name
   */
  name: string;
  
  /**
   * Destination canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Destination short introductional text
   */
  excerpt?: string;
  
  /**
   * Destination description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking destination as featured on some lists
   */
  featured: boolean;
  
  /**
   * Destination map image
   */
  mapImage?: GQLImage;
  
  /**
   * List of areas attached to destination
   */
  areas: GQLAreaConnection;
  
  /**
   * Gallery images/videos for destination
   */
  images: Array<GQLImage>;
  
  /**
   * List of articles related to destination
   */
  articles: Array<GQLArticle>;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * Price for fly tickets
   */
  priceFlyTicket?: GQLPrice;
  
  /**
   * Currency in which are prices
   */
  currency: GQLCurrency;
  
  /**
   * List of hotels in destination
   */
  hotels: GQLHotelConnection;
}

/**
 * Node interface
 */
export interface GQLNode {
  id: string;
}

/** Use this to resolve interface type Node */
export type GQLPossibleNodeTypeNames =
'Destination' |
'Area' |
'Beach' |
'Hotel' |
'Activity' |
'Event' |
'SearchVacancy';

export interface GQLNodeNameMap {
  Node: GQLNode;
  Destination: GQLDestination;
  Area: GQLArea;
  Beach: GQLBeach;
  Hotel: GQLHotel;
  Activity: GQLActivity;
  Event: GQLEvent;
  SearchVacancy: GQLSearchVacancy;
}

/**
 * ### Image type
 */
export interface GQLImage {
  
  /**
   * Record UUID
   */
  id: string;
  
  /**
   * Path to original image
   */
  path: string;
  
  /**
   * Description text
   */
  description?: string;
  
  /**
   * MIME type of image
   */
  mimeType: string;
  
  /**
   * Video URL
   */
  videoUrl?: string;
  
  /**
   * Size of file
   */
  fileSize: number;
  
  /**
   * Width of image
   */
  width: number;
  
  /**
   * Height of image
   */
  height: number;
  
  /**
   * URL to original image
   */
  src: string;
  
  /**
   * Image srcset attribute
   */
  srcset: string;
  
  /**
   * Image order rank
   */
  rank: number;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * List of image formats
   */
  formats: Array<GQLImageFormat>;
}

/**
 * Date and time in the RFC3339 format
 */
export type GQLDateTime = any;

export interface GQLImageFormat {
  path: string;
  name: GQLImageFormatName;
  width: number;
}

export enum GQLImageFormatName {
  
  /**
   * Original file format
   */
  SOURCE = 'SOURCE',
  THUMBNAIL = 'THUMBNAIL',
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
  EXTRA_LARGE = 'EXTRA_LARGE'
}

/**
 * ### Return type for area query
 */
export interface GQLAreaConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLAreaEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### Area edge definition
 */
export interface GQLAreaEdge extends GQLEdge {
  
  /**
   * Node with area data
   */
  node: GQLArea;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Area entity
 */
export interface GQLArea extends GQLNode {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Area name
   */
  name: string;
  
  /**
   * Area canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Area intro text
   */
  excerpt?: string;
  
  /**
   * Area description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Destination, where area belongs to
   */
  destination: GQLDestination;
  
  /**
   * Gallery images/videos for area
   */
  images: Array<GQLImage>;
  
  /**
   * List of beaches in area
   */
  beaches: GQLBeachConnection;
  
  /**
   * List of hotels in area
   */
  hotels: GQLHotelConnection;
  
  /**
   * Integration code for Juniper API
   */
  jpdCode?: string;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * Flag for marking area as featured on some lists
   */
  featured: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * Price for transfers
   */
  priceTransfer?: GQLPrice;
  
  /**
   * Currency in which are prices
   */
  currency: GQLCurrency;
}

/**
 * ### Return type for beach query
 */
export interface GQLBeachConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLBeachEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### Beach edge definition
 */
export interface GQLBeachEdge extends GQLEdge {
  
  /**
   * Node with beach data
   */
  node: GQLBeach;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Beach entity
 */
export interface GQLBeach extends GQLNode, GQLBeachInterface {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Beach name
   */
  name: string;
  
  /**
   * Beach canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Beach intro text
   */
  excerpt?: string;
  
  /**
   * Beach description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Area, where beach belongs to
   */
  area: GQLArea;
  
  /**
   * Gallery images/videos for beach
   */
  images: Array<GQLImage>;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * List of related hotels
   */
  hotels: GQLHotelConnection;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * SEO description
   */
  description?: string;
}

export interface GQLBeachInterface {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Beach name
   */
  name: string;
  
  /**
   * Beach canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Beach intro text
   */
  excerpt?: string;
  
  /**
   * Beach description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Area, where beach belongs to
   */
  area: GQLArea;
  
  /**
   * Gallery images/videos for beach
   */
  images: Array<GQLImage>;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * List of related hotels
   */
  hotels: GQLHotelConnection;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * SEO description
   */
  description?: string;
}

/** Use this to resolve interface type BeachInterface */
export type GQLPossibleBeachInterfaceTypeNames = 'Beach' | 'HotelBeach';

export interface GQLBeachInterfaceNameMap {
  BeachInterface: GQLBeachInterface;
  Beach: GQLBeach;
  HotelBeach: GQLHotelBeach;
}

/**
 * ### Slug type
 */
export interface GQLSlug {
  
  /**
   * UUID of record
   */
  id: string;
  
  /**
   * Slug path
   */
  slug: string;
  
  /**
   * If slug is canonical
   */
  canonical: boolean;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Enumeration for state of record
 */
export enum GQLRecordState {
  PUBLISHED = 'PUBLISHED',
  DRAFT = 'DRAFT',
  REVIEW = 'REVIEW',
  FORBIDDEN = 'FORBIDDEN'
}

/**
 * ### Return type for hotel query
 */
export interface GQLHotelConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLHotelEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### Hotel edge definition
 */
export interface GQLHotelEdge extends GQLEdge {
  
  /**
   * Node with hotel data
   */
  node: GQLHotel;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Hotel entity
 */
export interface GQLHotel extends GQLNode {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Hotel name
   */
  name: string;
  
  /**
   * Hotel canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Whether the header should be darkened
   */
  darkHeader: boolean;
  
  /**
   * Short introductional text
   */
  excerpt?: string;
  
  /**
   * Description, used as page source
   */
  content?: string;
  
  /**
   * GPS coordinate of hotel position
   */
  latitude?: number;
  
  /**
   * GPS coordinate of hotel position
   */
  longitude?: number;
  
  /**
   * Distance to beach
   */
  distanceToBeach?: string;
  
  /**
   * Type of hotel
   */
  hotelType: GQLHotelType;
  
  /**
   * Area, where hotel belongs to
   */
  area: GQLArea;
  
  /**
   * List of hotel beaches
   */
  beaches: Array<GQLHotelBeach>;
  
  /**
   * List of tags
   */
  tags: Array<GQLTag>;
  
  /**
   * List of activities
   */
  activities: Array<GQLActivity>;
  
  /**
   * List of events
   */
  events: Array<GQLEvent>;
  
  /**
   * List of galleries
   */
  images: Array<GQLImage>;
  
  /**
   * List of reviews
   */
  reviews: Array<GQLHotelReview>;
  
  /**
   * Average rating from user reviews
   */
  averageRating: number;
  
  /**
   * Integration code for Juniper API
   */
  jpdCode?: string;
  
  /**
   * Integration code for old Elixir web
   */
  wpCode?: string;
  
  /**
   * List of hotel rooms
   */
  rooms: Array<GQLRoom>;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * List of articles related to hotel
   */
  articles: Array<GQLArticle>;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * Best package ever
   */
  promoPackage?: GQLPackage;
  
  /**
   * Flag for hiding fly ticket price
   */
  hideFlyTicketPrice: boolean;
  
  /**
   * Flag for hiding transfer price
   */
  hideTransferPrice: boolean;
  
  /**
   * Lowest package price
   */
  priceFrom?: GQLPrice;
  
  /**
   * List of distinct boards offered in hotel packages
   */
  boards: Array<GQLBoard>;
}

/**
 * ### Hotel type entity
 */
export interface GQLHotelType {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Hotel type name
   */
  name: string;
  
  /**
   * Hotel type slug, created from its name
   */
  slug: string;
  
  /**
   * Numeric representation of hotel type
   */
  stars: number;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * List of hotels with this type
   */
  hotels: GQLHotelConnection;
}

/**
 * ### Relation between hotel and beach
 */
export interface GQLHotelBeach extends GQLBeachInterface {
  
  /**
   * If beach is situated right next to hotel
   */
  nextToHotel: boolean;
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Beach name
   */
  name: string;
  
  /**
   * Beach canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Beach intro text
   */
  excerpt?: string;
  
  /**
   * Beach description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Area, where beach belongs to
   */
  area: GQLArea;
  
  /**
   * Gallery images/videos for beach
   */
  images: Array<GQLImage>;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * List of related hotels
   */
  hotels: GQLHotelConnection;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * SEO description
   */
  description?: string;
}

/**
 * ###Tag entity
 */
export interface GQLTag {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Tag name
   */
  name: string;
  
  /**
   * Tag slug, created from its name
   */
  slug: string;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Activity entity
 */
export interface GQLActivity extends GQLNode {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Activity name
   */
  name: string;
  
  /**
   * Activity intro text
   */
  excerpt?: string;
  
  /**
   * Activity description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking activity as featured on some lists
   */
  featured: boolean;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * List image
   */
  listImage?: GQLImage;
}

/**
 * ###Event entity
 */
export interface GQLEvent extends GQLNode {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Event name
   */
  name: string;
  
  /**
   * Event slug, created from its name
   */
  slug: string;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Hotel review
 */
export interface GQLHotelReview {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Reviewed hotel
   */
  hotel: GQLHotel;
  
  /**
   * Review rating
   */
  rating: number;
  
  /**
   * Review description
   */
  description: string;
  
  /**
   * Author of review
   */
  author?: string;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Room
 */
export interface GQLRoom {
  
  /**
   * UUID of record
   */
  id: string;
  
  /**
   * Hotel where room belongs to
   */
  hotel: GQLHotel;
  
  /**
   * Room name
   */
  name: string;
  
  /**
   * Short introductional text
   */
  excerpt?: string;
  
  /**
   * Description, used as page source
   */
  content?: string;
  
  /**
   * Area of room in square meters
   */
  area: number;
  
  /**
   * Flag for marking room as featured on some lists
   */
  featured: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * List of galleries
   */
  images: Array<GQLImage>;
  
  /**
   * List of occupancies
   */
  occupancies: Array<GQLOccupancy>;
}

/**
 * ### Occupancy
 */
export interface GQLOccupancy {
  
  /**
   * UUID of record
   */
  id: string;
  
  /**
   * Room to where occupancy is related
   */
  room: GQLRoom;
  
  /**
   * Occupancy name
   */
  name: string;
  
  /**
   * Number of adults
   */
  adult: number;
  
  /**
   * Number of kids
   */
  child: number;
  
  /**
   * Extra bed in room possible
   */
  extraBed: boolean;
  
  /**
   * List of packages
   */
  packages: GQLPackageConnection;
}

/**
 * Package filters
 */
export enum GQLPackageSelector {
  
  /**
   * Returns all record
   */
  ALL = 'ALL',
  
  /**
   * Returns records having searchableFrom < now and searchableTo > now
   */
  ACTIVE = 'ACTIVE',
  
  /**
   * Returns records having searchableTo < now
   */
  INACTIVE = 'INACTIVE',
  
  /**
   * Returns records having searchableFrom > now
   */
  FUTURE = 'FUTURE'
}

/**
 * Packages sorting fields
 */
export enum GQLPackageSort {
  BY_SEARCHABLE_FROM = 'BY_SEARCHABLE_FROM',
  BY_SEARCHABLE_TO = 'BY_SEARCHABLE_TO',
  BY_VALID_FROM = 'BY_VALID_FROM'
}

/**
 * ### Return type for package query
 */
export interface GQLPackageConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLPackageEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### Package edge definition
 */
export interface GQLPackageEdge extends GQLEdge {
  
  /**
   * Node with package data
   */
  node: GQLPackage;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Type for package
 */
export interface GQLPackage {
  
  /**
   * UUID of record
   */
  id: string;
  
  /**
   * Occupancy to which package belongs to
   */
  occupancy: GQLOccupancy;
  
  /**
   * Package name
   */
  name: string;
  
  /**
   * Package description
   */
  description?: string;
  
  /**
   * Type of package
   */
  type: GQLPackageType;
  
  /**
   * Board type
   */
  board: GQLBoard;
  
  /**
   * Package is optimized for the set number of nights
   */
  numberOfNights: number;
  
  /**
   * Date from which is package valid
   */
  validFrom: GQLDateTime;
  
  /**
   * Date too wchi is package valid
   */
  validTo: GQLDateTime;
  
  /**
   * Price for accomodation
   */
  priceAccommodation: GQLPrice;
  
  /**
   * Price for a transfer
   */
  priceTransfer?: GQLPrice;
  
  /**
   * Price for a flight ticket
   */
  priceFlyTicket?: GQLPrice;
  
  /**
   * Total price of package
   */
  priceTotal: GQLPrice;
  
  /**
   * Package is visible to users from this date
   */
  searchableFrom: GQLDateTime;
  
  /**
   * Package is no longer visible to users after this date
   */
  searchableTo: GQLDateTime;
  
  /**
   * Currency in which are prices
   */
  currency: GQLCurrency;
  
  /**
   * If package is featured
   */
  featured: boolean;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Enumeration for package type
 */
export enum GQLPackageType {
  DEFAULT = 'DEFAULT',
  ACTION = 'ACTION',
  SPECIAL = 'SPECIAL',
  WEDDING = 'WEDDING'
}

/**
 * ### Board entity
 */
export interface GQLBoard {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Board name
   */
  name: string;
  
  /**
   * Weight used for custom sorting
   */
  rank: number;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Price type
 */
export interface GQLPrice {
  
  /**
   * Price value
   */
  amount: number;
  
  /**
   * Price currency
   */
  currency: GQLCurrency;
}

/**
 * ### Currency entity
 */
export interface GQLCurrency {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Internatinal currency code (ISO 4217)
   */
  code: string;
  
  /**
   * Currency name
   */
  name: string;
  
  /**
   * Amount of currency you get for the exchange
   */
  amount: number;
  
  /**
   * Exhange ratio - how much CZK you have to pay to get defined amount of currency
   */
  ratio: number;
  
  /**
   * Histroy of exchange ratio
   */
  history: Array<GQLCurrencyHistory>;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Currency exchange ratios history entity
 */
export interface GQLCurrencyHistory {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Exchnage ratio
   */
  ratio: number;
  
  /**
   * Variance of current ration against last one
   */
  variance: number;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Article type
 */
export interface GQLArticle {
  
  /**
   * Record identifier (UUID)
   */
  id: string;
  
  /**
   * Element name
   */
  name: string;
  
  /**
   * Destination canonical slug
   */
  canonicalSlug: string;
  
  /**
   * Destination short introductional text
   */
  excerpt?: string;
  
  /**
   * Destination description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking destination as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * List of slugs
   */
  slugs: Array<GQLSlug>;
  
  /**
   * Featured image
   */
  featuredImage?: GQLImage;
  
  /**
   * List image
   */
  listImage?: GQLImage;
  
  /**
   * List of destinations related to article
   */
  destinations: Array<GQLDestination>;
  
  /**
   * List of hotels related to article
   */
  hotels: Array<GQLHotel>;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
  
  /**
   * SEO description
   */
  description?: string;
}

export interface GQLHotelSelector {
  areaId?: string;
  hotelTypeId?: string;
  beachId?: string;
  packageType?: GQLPackageType;
}

/**
 * Possible hotel sorting fields
 */
export enum GQLHotelSort {
  BY_AVERAGE_RATING = 'BY_AVERAGE_RATING',
  BY_DISTANCE_TO_BEACH = 'BY_DISTANCE_TO_BEACH',
  BY_NAME = 'BY_NAME',
  BY_PRICE = 'BY_PRICE'
}

/**
 * ### Areas
 */
export interface GQLAreas {
  
  /**
   * List of areas
   */
  list: GQLAreaConnection;
  
  /**
   * ### Get single area by id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired area
   */
  get?: GQLArea;
  
  /**
   * ### Get single area by slug
   * 
   * **Query parameters**:
   * - *slug* (String): slug of desired area
   */
  getBySlug?: GQLArea;
}

export interface GQLAreaSelector {
  destinationId?: string;
}

/**
 * ### Boards
 * Boards identify meal services which customer can get during his vacation
 */
export interface GQLBoards {
  
  /**
   * ### List of boards
   * Query returns list of boards based on query parameters
   * 
   * **Query parameters**:
   * - *sortBy* (String): sorts results by field specified
   * - *sortOrder* (String): sorts results order (asc, desc)
   */
  list: Array<GQLBoard>;
  
  /**
   * ### Get single board by its id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired board
   */
  get?: GQLBoard;
}

/**
 * ### Currencies
 * List of currencies used in application
 */
export interface GQLCurrencies {
  
  /**
   * ### List of currencies
   * Query returns list of currencies based on query parameters
   * 
   * **Query parameters**:
   * - *sortBy* (String): sorts results by field specified
   * - *sortOrder* (String): sorts results order (asc, desc)
   */
  list: Array<GQLCurrency>;
  
  /**
   * ### Get single currency by its id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired currency
   */
  get?: GQLCurrency;
}

/**
 * ### Tags
 */
export interface GQLTags {
  
  /**
   * ### List of tags
   * Query returns list of tags based on query parameters
   * 
   * **Query parameters**:
   * - *sortBy* (String): sorts results by field specified
   * - *sortOrder* (String): sorts results order (asc, desc)
   */
  list: Array<GQLTag>;
  
  /**
   * ### Get single tag by its id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired tag
   */
  get?: GQLTag;
  
  /**
   * ### Get single tag by its slug
   * 
   * **Query parameters**:
   * - *slug* (String): slug of desired tag
   */
  getBySlug?: GQLTag;
}

/**
 * ### Activities
 */
export interface GQLActivities {
  
  /**
   * List of activities
   */
  list: GQLActivityConnection;
  
  /**
   * ### Get single activity by id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired activity
   */
  get?: GQLActivity;
}

/**
 * ### Return type for actvities query
 */
export interface GQLActivityConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLActivityEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### Activity edge definition
 */
export interface GQLActivityEdge extends GQLEdge {
  
  /**
   * Node with activity data
   */
  node: GQLActivity;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Beaches
 */
export interface GQLBeaches {
  
  /**
   * List of beaches
   */
  list: GQLBeachConnection;
  
  /**
   * ### Get single beach by id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired beach
   */
  get?: GQLBeach;
  
  /**
   * ### Get single beach by slug
   * 
   * **Query parameters**:
   * - *slug* (String): slug of desired beach
   */
  getBySlug?: GQLBeach;
}

export interface GQLBeachSelector {
  areaId?: string;
}

/**
 * ### HotelTypes
 */
export interface GQLHotelTypes {
  
  /**
   * ### List of hotel types
   * Query returns list of hotel types based on query parameters
   * 
   * **Query parameters**:
   * - *sortBy* (String): sorts results by field specified
   * - *sortOrder* (String): sorts results order (asc, desc)
   */
  list: Array<GQLHotelType>;
  
  /**
   * ### Get single hotel type by its id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired hotel type
   */
  get?: GQLHotelType;
  
  /**
   * ### Get single hotel type by its slug
   * 
   * **Query parameters**:
   * - *slug* (String): slug of desired hotel type
   */
  getBySlug?: GQLHotelType;
}

/**
 * ### Events
 */
export interface GQLEvents {
  
  /**
   * List of events
   */
  list: GQLEventConnection;
  
  /**
   * ### Get single event by its id
   * 
   * **Query parameters**:
   * - *id* (String): UUID of desired event
   */
  get?: GQLEvent;
  
  /**
   * ### Get single event by its slug
   * 
   * **Query parameters**:
   * - *slug* (String): slug of desired event
   */
  getBySlug?: GQLEvent;
}

/**
 * ### Return type for events query
 */
export interface GQLEventConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLEventEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### Event edge definition
 */
export interface GQLEventEdge extends GQLEdge {
  
  /**
   * Node with event data
   */
  node: GQLEvent;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Hotels
 */
export interface GQLHotels {
  
  /**
   * List of hotels
   */
  list: GQLHotelConnection;
  
  /**
   * Returns hotel by its ID
   */
  get?: GQLHotel;
  
  /**
   * Returns hotel by its slug
   */
  getBySlug?: GQLHotel;
  
  /**
   * Return list of promoted hotels
   */
  promoted: Array<GQLHotel>;
  
  /**
   * Returns list of hotels for carousel
   */
  carousel: Array<GQLHotel>;
}

export interface GQLElixirServices {
  list: Array<GQLElixirService>;
}

export interface GQLElixirService {
  id: number;
  title: string;
  excerpt?: string;
  lastModified: GQLDateTime;
  guid: string;
  parentId: number;
}

export interface GQLElixirBeaches {
  list: Array<GQLElixirBeach>;
  get: GQLElixirBeach;
}

export interface GQLElixirBeach {
  id: number;
  title: string;
  content?: string;
  excerpt?: string;
  lastModified: GQLDateTime;
  guid: string;
  parentId: number;
  videos?: string;
  latitude?: number;
  longitude?: number;
  services: Array<GQLElixirService>;
}

export interface GQLElixirHotels {
  list: Array<GQLElixirHotel>;
  get?: GQLElixirHotel;
  inventory: Array<GQLElixirHotelInventory>;
}

export interface GQLElixirHotel {
  id?: number;
  title: string;
  content?: string;
  excerpt?: string;
  guid: string;
  lastModified: GQLDateTime;
  featuredImage?: string;
  categories: Array<GQLElixirCategory>;
  boards: Array<GQLElixirBoard>;
  activities: Array<GQLElixirActivity>;
  islands: Array<GQLElixirIsland>;
  capacities: Array<GQLElixirCapacity>;
  galleries: Array<GQLElixirImage>;
  rooms: Array<GQLElixirRoom>;
  prices: Array<GQLElixirPrice>;
}

export interface GQLElixirCategory {
  id?: number;
  title: string;
  description?: string;
}

export interface GQLElixirBoard {
  id?: number;
  title: string;
  description?: string;
}

export interface GQLElixirActivity {
  id?: number;
  title: string;
  excerpt?: string;
  guid: string;
  lastModified: GQLDateTime;
  parent?: number;
}

export interface GQLElixirIsland {
  id?: number;
  title: string;
  description?: string;
  parentId: number;
}

export interface GQLElixirCapacity {
  id?: number;
  title: string;
  description?: string;
}

export interface GQLElixirImage {
  id?: number;
  title: string;
  excerpt?: string;
  guid: string;
  lastModified: GQLDateTime;
  parent?: number;
  mimeType: string;
}

export interface GQLElixirRoom {
  id?: number;
  title: string;
  content?: string;
  excerpt?: string;
  guid: string;
  lastModified: GQLDateTime;
  galleries: Array<GQLElixirImage>;
  packages: Array<GQLElixirPackage>;
}

export interface GQLElixirPackage {
  id?: number;
  title: string;
  excerpt?: string;
  length: number;
  board: string;
  dateFrom: GQLDateTime;
  dateTo: GQLDateTime;
  priceAccommodation: number;
  priceTransfer: number;
  priceFlight: number;
  guid: string;
  lastModified: GQLDateTime;
}

export interface GQLElixirPrice {
  id?: number;
  title: string;
  description?: string;
}

export interface GQLElixirHotelInventory {
  id: number;
  name: string;
  imported: boolean;
}

export interface GQLJuniperHotels {
  
  /**
   * Returns list of Juniper hotels
   */
  list: Array<GQLJuniperHotelList>;
  
  /**
   * Return Juniper hotel definition
   */
  get: GQLJuniperHotel;
  
  /**
   * Returns list of hotel rooms by category
   */
  roomCategoryList: Array<GQLJuniperRoomCategory>;
}

export interface GQLJuniperHotelList {
  hotelCode: string;
  name: string;
  imported: boolean;
}

export interface GQLJuniperHotel {
  hotelCode: string;
  name: string;
  category?: GQLJuniperHotelCategory;
  address?: GQLJuniperHotelAddress;
  roomTypes: Array<GQLJuniperHotelRoom>;
  boards: Array<GQLJuniperBoard>;
  paymentCards: Array<GQLJuniperPaymentCard>;
  features: Array<GQLJuniperFeature>;
  images: Array<string>;
  hotelCodeEncrypt?: string;
  shortDescription?: string;
  longDescription?: string;
}

export interface GQLJuniperHotelCategory {
  id?: number;
  name?: string;
}

export interface GQLJuniperHotelAddress {
  address?: string;
  city?: GQLJuniperCity;
  zip?: string;
  bookingEmail?: string;
  bookingFax?: string;
  bookingPhone?: string;
  coordinates?: GQLJuniperCoordinates;
}

export interface GQLJuniperCity {
  code?: number;
  name?: string;
}

export interface GQLJuniperCoordinates {
  latitude?: number;
  longitude?: number;
}

export interface GQLJuniperHotelRoom {
  id: number;
  occupancy?: GQLJuniperOccupancy;
  descriptions: Array<GQLJuniperDescription>;
  name?: string;
  max?: number;
  addiFrom?: number;
  childAsAdult?: boolean;
  alter?: number;
  roomTypeCategoryID?: number;
  roomTypeCategoryName?: string;
  nonRefundable?: boolean;
  infantAsChild?: boolean;
}

export interface GQLJuniperOccupancy {
  minChild?: number;
  maxChild?: number;
  minAdult?: number;
  maxAdult?: number;
}

export interface GQLJuniperDescription {
  type?: number;
  text?: string;
}

export interface GQLJuniperBoard {
  code?: number;
  name?: string;
}

export interface GQLJuniperPaymentCard {
  code?: string;
  name?: string;
}

export interface GQLJuniperFeature {
  code?: number;
  name?: string;
  payment?: boolean;
}

export interface GQLJuniperRoomCategory {
  roomTypeCategoryID?: number;
  roomTypeCategoryName?: string;
}

/**
 * ### Newsletters
 */
export interface GQLNewsletters {
  
  /**
   * ### List of newsletter subscribers"
   * Query returns list of newsletter subscribers
   * 
   * **Query parameters**:
   * - *verifiedOnly* (Boolean): filters results by verfied field
   */
  list: Array<GQLNewsletter>;
}

/**
 * ### Newsletter type
 */
export interface GQLNewsletter {
  
  /**
   * UUID of record
   */
  id: string;
  
  /**
   * Registered e-mail address
   */
  email: string;
  
  /**
   * E-mail address veryfication flag
   */
  verified: boolean;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### References
 */
export interface GQLReferences {
  
  /**
   * ### List of references"
   * Query returns list of references
   * 
   * **Query parameters**:
   * - *verifiedOnly* (Boolean): filters results by verified field
   */
  list: Array<GQLReference>;
}

/**
 * ### Type of reference
 */
export interface GQLReference {
  
  /**
   * UUID of record
   */
  id: string;
  
  /**
   * Reference author name
   */
  author: string;
  
  /**
   * Text of reference
   */
  description: string;
  
  /**
   * Record state
   */
  state: GQLRecordState;
  
  /**
   * Date and time of record creation
   */
  created: GQLDateTime;
  
  /**
   * Date and time of last record modification
   */
  lastModified: GQLDateTime;
}

/**
 * ### Routing queries
 */
export interface GQLRoutes {
  get?: GQLRouteResult;
}

export type GQLRouteResult =
GQLHotel |
GQLBeach |
GQLArea |
GQLDestination |
GQLArticle;

/** Use this to resolve union type RouteResult */
export type GQLPossibleRouteResultTypeNames =
'Hotel' |
'Beach' |
'Area' |
'Destination' |
'Article';

export interface GQLRouteResultNameMap {
  RouteResult: GQLRouteResult;
  Hotel: GQLHotel;
  Beach: GQLBeach;
  Area: GQLArea;
  Destination: GQLDestination;
  Article: GQLArticle;
}

/**
 * # Packages
 */
export interface GQLPackages {
  
  /**
   * List of packages
   */
  list: GQLPackageConnection;
}

/**
 * ### Setting queries
 */
export interface GQLSettings {
  
  /**
   * Returns list of requested parameters
   */
  list: Array<GQLSetting>;
  
  /**
   * Returns list of social networks
   */
  socialNetworks: Array<GQLSocialNetwork>;
}

/**
 * ### Setting type
 */
export interface GQLSetting {
  
  /**
   * Name of the parameter
   */
  parameterName: string;
  
  /**
   * Value of parameter
   */
  parameterValue: string;
}

/**
 * ### Social network type
 */
export interface GQLSocialNetwork {
  network: string;
  url: string;
}

/**
 * ### Search types
 */
export interface GQLSearch {
  vacancy: GQLSearchVacancyConnection;
  hotel: GQLSearchHotelConnection;
}

/**
 * ### Type for defining vacancy search query
 */
export interface GQLSearchVacancyQuery {
  
  /**
   * Start date of vacancy search range
   */
  validFrom: GQLDateTime;
  
  /**
   * End date of vacancy search range
   */
  validTo: GQLDateTime;
  
  /**
   * Required number of adults
   */
  adults?: number;
  
  /**
   * Required number of kids
   */
  children?: number;
  
  /**
   * Minimal number of required nights
   */
  numberOfNightsFrom: number;
  
  /**
   * Maximal number of required nights
   */
  numberOfNightsTo: number;
  
  /**
   * Currency code for price transformation
   */
  currencyCode: string;
  
  /**
   * Array of UUIDs of desired destinations
   */
  destinations?: Array<string>;
  
  /**
   * Array of UUIDs of desired tags
   */
  tags?: Array<string>;
  
  /**
   * Array of UUIDs of desired events
   */
  events?: Array<string>;
  
  /**
   * Array of UUIDs of desired boards
   */
  boards?: Array<string>;
  
  /**
   * Array of UUIDs of desired hotel types
   */
  hotelTypes?: Array<string>;
}

/**
 * Vacancy search sorting
 */
export enum GQLSearchVacancySort {
  
  /**
   * Sort by cheapest package
   */
  CHEAPEST = 'CHEAPEST',
  
  /**
   * Sort by most expensive package
   */
  EXPENSIVE = 'EXPENSIVE',
  
  /**
   * Sort by average hotel rating
   */
  RATING = 'RATING'
}

/**
 * ### Return type for search vacancy query
 */
export interface GQLSearchVacancyConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLSearchVacancyEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### SearchVacancy edge definition
 */
export interface GQLSearchVacancyEdge extends GQLEdge {
  
  /**
   * Node with vacancy data
   */
  node: GQLSearchVacancy;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * ### Type for search vacancy result
 */
export interface GQLSearchVacancy extends GQLNode {
  
  /**
   * Hotel UUID
   */
  id: string;
  
  /**
   * Hotel relation
   */
  hotel: GQLHotel;
  
  /**
   * Package UUID
   */
  packageId: string;
  
  /**
   * Name of board
   */
  boardName: string;
  
  /**
   * Package price
   */
  price: GQLPrice;
  
  /**
   * Number of nights
   */
  numberOfNights: number;
}

/**
 * ### Type for defining hotel search query
 */
export interface GQLSearchHotelQuery {
  name: string;
  state?: GQLRecordState;
}

/**
 * ### Return type for search hotel query
 */
export interface GQLSearchHotelConnection extends GQLConnection {
  
  /**
   * List of edges
   */
  edges: Array<GQLSearchHotelEdge>;
  
  /**
   * Pagination information.
   */
  pageInfo: GQLPageInfo;
  
  /**
   * Total count of items based on the filtered query
   */
  totalCount: number;
}

/**
 * ### SearchHotel edge definition
 */
export interface GQLSearchHotelEdge extends GQLEdge {
  
  /**
   * Node with hotel data
   */
  node: GQLHotel;
  
  /**
   * Edge identifier
   */
  cursor: string;
}

/**
 * Endpoint for handling users
 */
export interface GQLUsers {
  
  /**
   * Return the information about currently logged in user
   */
  getCurrentLogin?: GQLCurrentLogin;
  
  /**
   * Perform login and return token if successfull
   */
  login: GQLLogin;
  
  /**
   * Uses current login to refresh the token
   */
  refresh?: GQLLogin;
}

/**
 * Return type for currently logged in user
 */
export interface GQLCurrentLogin {
  
  /**
   * Timestamp of token expiry
   */
  expires: GQLDateTime;
  user: GQLUser;
}

export interface GQLUser {
  username: string;
}

/**
 * Return type for a succesfull login operation
 */
export interface GQLLogin {
  
  /**
   * Timestamp of token expiry
   */
  expires: GQLDateTime;
  
  /**
   * Encoded token that can be send in a cookie or X-AUTH-TOKEN header
   */
  token: string;
  
  /**
   * Name of the cookie that should be used with the token
   */
  tokenName: string;
  user: GQLUser;
}

export interface GQLRootMutation {
  
  /**
   * Creates new destination
   */
  createDestination: GQLDestination;
  
  /**
   * Updates exiting destination
   */
  updateDestination: GQLDestination;
  
  /**
   * Deletes existing destination
   */
  deleteDestination: boolean;
  
  /**
   * Adds slug to destination
   */
  addDestinationSlug: GQLSlug;
  
  /**
   * Updates existing destination slug
   */
  updateDestinationSlug: GQLSlug;
  
  /**
   * Deletes existing destination slug
   */
  deleteDestinationSlug: boolean;
  
  /**
   * Creates new destination image of specified type
   */
  addDestinationImage: GQLImage;
  
  /**
   * Updates existing destination image of specified
   */
  updateDestinationImage: GQLImage;
  
  /**
   * Deletes existing destination image of specified
   */
  deleteDestinationImage: boolean;
  
  /**
   * Moves image in gallery onto new position
   */
  changeDestinationImageRank: boolean;
  
  /**
   * Creates new area
   */
  createArea: GQLArea;
  
  /**
   * Updates existing area
   */
  updateArea: GQLArea;
  
  /**
   * Deletes existing area
   */
  deleteArea: boolean;
  
  /**
   * Adds slug to area
   */
  addAreaSlug: GQLSlug;
  
  /**
   * Updates existing area slug
   */
  updateAreaSlug: GQLSlug;
  
  /**
   * Deletes existing area slug
   */
  deleteAreaSlug: boolean;
  
  /**
   * Creates new area image of specified type
   */
  addAreaImage: GQLImage;
  
  /**
   * Updates existing area image of specified type
   */
  updateAreaImage: GQLImage;
  
  /**
   * Deletes existing area image of specified type
   */
  deleteAreaImage: boolean;
  
  /**
   * Moves image in gallery onto new position
   */
  changeAreaImageRank: boolean;
  
  /**
   * Creates new hotel
   */
  createHotel: GQLHotel;
  
  /**
   * Updates existing hotel
   */
  updateHotel: GQLHotel;
  
  /**
   * Deletes existing hotel
   */
  deleteHotel: boolean;
  
  /**
   * Adds slug to hotel
   */
  addHotelSlug: GQLSlug;
  
  /**
   * Updates existing hotel slug
   */
  updateHotelSlug: GQLSlug;
  
  /**
   * Deletes existing hotel slug
   */
  deleteHotelSlug: boolean;
  
  /**
   * Adds new hotel image of specified type
   */
  addHotelImage: GQLImage;
  
  /**
   * Updates existing hotel image of specified type
   */
  updateHotelImage: GQLImage;
  
  /**
   * Deletes existing hotel image of specified type
   */
  deleteHotelImage: boolean;
  
  /**
   * Moves image in gallery onto new position
   */
  changeHotelImageRank: boolean;
  
  /**
   * Relates package as promo to given hotel
   */
  setHotelPromoPackage: boolean;
  
  /**
   * Removes package as promo from given hotel
   */
  unsetHotelPromoPackage: boolean;
  
  /**
   * Creates new room in desired hotel
   */
  createRoom: GQLRoom;
  
  /**
   * Updates existing room
   */
  updateRoom: GQLRoom;
  
  /**
   * Deletes existing room
   */
  deleteRoom: boolean;
  
  /**
   * Adds new room image of specified type
   */
  addRoomImage: GQLImage;
  
  /**
   * Updates existing room image of specified type
   */
  updateRoomImage: GQLImage;
  
  /**
   * Deletes existing room image of specified type
   */
  deleteRoomImage: boolean;
  
  /**
   * Moves image in gallery onto new position
   */
  changeRoomImageRank: boolean;
  
  /**
   * Creates new occupancy under given room
   */
  createOccupancy: GQLOccupancy;
  
  /**
   * Updates existing occupancy
   */
  updateOccupancy: GQLOccupancy;
  
  /**
   * Deletes existing occupancy
   */
  deleteOccupancy: boolean;
  
  /**
   * Creates new beach
   */
  createBeach: GQLBeach;
  
  /**
   * Updates existing beach
   */
  updateBeach: GQLBeach;
  
  /**
   * Deletes existing beach
   */
  deleteBeach: boolean;
  
  /**
   * Adds slug to beach
   */
  addBeachSlug: GQLSlug;
  
  /**
   * Updates existing beach slug
   */
  updateBeachSlug: GQLSlug;
  
  /**
   * Deletes existing beach slug
   */
  deleteBeachSlug: boolean;
  
  /**
   * Creates new beach image of specified type
   */
  addBeachImage: GQLImage;
  
  /**
   * Updates existing beach image of specified type
   */
  updateBeachImage: GQLImage;
  
  /**
   * Deletes existing beach image of specified type
   */
  deleteBeachImage: boolean;
  
  /**
   * Moves image in gallery onto new position
   */
  changeBeachImageRank: boolean;
  
  /**
   * Creates new price package
   */
  createPackage: GQLPackage;
  
  /**
   * Updates existing package
   */
  updatePackage: GQLPackage;
  
  /**
   * Deletes existing package
   */
  deletePackage: boolean;
  
  /**
   * Relates given beach to desired hotel
   */
  relateBeachToHotel: GQLHotelBeach;
  
  /**
   * Deletes relation between hotel and beach
   */
  unrelateBeachFromHotel: boolean;
  
  /**
   * Updates relation betwwen given beach and desired hotel
   */
  updateHotelBeach: GQLHotelBeach;
  
  /**
   * Relates given tag to desired hotel
   */
  relateTagToHotel: boolean;
  
  /**
   * Deletes relation between hotel and tag
   */
  unrelateTagFromHotel: boolean;
  
  /**
   * Relates given event to desired hotel
   */
  relateEventToHotel: boolean;
  
  /**
   * Deletes relation between hotel and event
   */
  unrelateEventFromHotel: boolean;
  
  /**
   * Relates given activity to desired hotel
   */
  relateActivityToHotel: boolean;
  
  /**
   * Deletes relation between hotel and activity
   */
  unrelateActivityFromHotel: boolean;
  
  /**
   * Creates new hotel review
   */
  createHotelReview: GQLHotelReview;
  
  /**
   * Updates existing hotel review
   */
  updateHotelReview: GQLHotelReview;
  
  /**
   * Deletes existing hotel review
   */
  deleteHotelReview: boolean;
  
  /**
   * Creates new tag
   */
  createTag: GQLTag;
  
  /**
   * Updates existing tag
   */
  updateTag: GQLTag;
  
  /**
   * Deletes existing tag
   */
  deleteTag: boolean;
  
  /**
   * Creates new board
   */
  createBoard: GQLBoard;
  
  /**
   * Updates existing board
   */
  updateBoard: GQLBoard;
  
  /**
   * Deletes existing board
   */
  deleteBoard: boolean;
  
  /**
   * Creates new currency
   */
  createCurrency: GQLCurrency;
  
  /**
   * Updates existing currency
   */
  updateCurrency: GQLCurrency;
  
  /**
   * Deletes existing currency
   */
  deleteCurrency: boolean;
  
  /**
   * Creates new event
   */
  createEvent: GQLEvent;
  
  /**
   * Updates existing event
   */
  updateEvent: GQLEvent;
  
  /**
   * Deletes existing event
   */
  deleteEvent: boolean;
  
  /**
   * Creates new hotel type
   */
  createHotelType: GQLHotelType;
  
  /**
   * Updates existing hotel type
   */
  updateHotelType: GQLHotelType;
  
  /**
   * Deletes existing hotel type
   */
  deleteHotelType: boolean;
  
  /**
   * Creates new activity
   */
  createActivity: GQLActivity;
  
  /**
   * Updates existing activity
   */
  updateActivity: GQLActivity;
  
  /**
   * Deletes existing activity
   */
  deleteActivity: boolean;
  
  /**
   * Creates new activity image of specified type
   */
  addActivityImage: GQLImage;
  
  /**
   * Updates existing activity image of specified type
   */
  updateActivityImage: GQLImage;
  
  /**
   * Creates new reference
   */
  createReference: GQLReference;
  
  /**
   * Updates existing reference
   */
  updateReference: GQLReference;
  
  /**
   * Deletes existing reference
   */
  deleteReference: boolean;
  
  /**
   * Registers email address for newsletter subscription
   */
  registerNewsletter: boolean;
  
  /**
   * Validates newsletter subscription
   */
  verifyNewsletter: boolean;
  
  /**
   * Removes email from newsletter subscription
   */
  removeNewsletter: boolean;
  
  /**
   * Creates new article
   */
  createArticle: GQLArticle;
  
  /**
   * Updates existing article
   */
  updateArticle: GQLArticle;
  
  /**
   * Deletes existing article
   */
  deleteArticle: boolean;
  
  /**
   * Adds slug to article
   */
  addArticleSlug: GQLSlug;
  
  /**
   * Updates existing article slug
   */
  updateArticleSlug: GQLSlug;
  
  /**
   * Deletes existing article slug
   */
  deleteArticleSlug: boolean;
  
  /**
   * Creates new article image of specified type
   */
  addArticleImage: GQLImage;
  
  /**
   * Updates existing article image of specified type
   */
  updateArticleImage: GQLImage;
  
  /**
   * Moves image in gallery onto new position
   */
  changeArticleImageRank: boolean;
  
  /**
   * Deletes existing article image of specified type
   */
  deleteArticleImage: boolean;
  
  /**
   * Removes article relation to hotel or destination
   */
  deleteArticleRelation: boolean;
  
  /**
   * Imports hotel from old elixir WP site
   */
  importElixirHotel: GQLHotel;
  
  /**
   * Imports packages from given room and hotel into specified occupancy
   */
  importElixirPackages: Array<GQLPackage>;
  
  /**
   * Import hotel from Creole (Juniper) FTP
   */
  importJuniperHotel: GQLHotel;
  
  /**
   * Imports occupancy of given Juniper hotel room category into room
   */
  importJuniperOccupancy: Array<GQLOccupancy>;
  
  /**
   * Saves/updates parameters with value
   */
  saveSettings: boolean;
  
  /**
   * Deletes parameter from setting
   */
  deleteSettings: boolean;
  
  /**
   * Sends data from inquiry form
   */
  inquiry: boolean;
  tailoredOffer: boolean;
  
  /**
   * Sends data from contact form
   */
  contact: boolean;
}

/**
 * ### Type for creating new destination
 */
export interface GQLDestinationCreate {
  
  /**
   * Element name
   */
  name: string;
  
  /**
   * Destination short introductional text
   */
  excerpt?: string;
  
  /**
   * Destination description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking destination as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * Price for fly tickets
   */
  priceFlyTicket?: number;
  
  /**
   * UUID of currency in which are prices
   */
  currencyId: string;
}

/**
 * ### Type for updating existing destination
 */
export interface GQLDestinationUpdate {
  
  /**
   * Element name
   */
  name?: string;
  
  /**
   * Destination short introductional text
   */
  excerpt?: string;
  
  /**
   * Destination description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking destination as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state?: GQLRecordState;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * Price for fly tickets
   */
  priceFlyTicket?: number;
  
  /**
   * UUID of currency in which are prices
   */
  currencyId?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new slug
 */
export interface GQLSlugCreate {
  
  /**
   * UUID of record where slug belongs to
   */
  referenceId: string;
  
  /**
   * Slug path
   */
  slug: string;
  
  /**
   * If slug is canonical
   */
  canonical: boolean;
}

/**
 * ### Type for updating existing slug
 */
export interface GQLSlugUpdate {
  
  /**
   * Slug path
   */
  slug: string;
  
  /**
   * If slug is canonical
   */
  canonical: boolean;
}

/**
 * ### Type for uploading images
 */
export interface GQLImageCreate {
  
  /**
   * Alt text of image
   */
  description?: string;
  
  /**
   * Uploaded file
   */
  file: GQLFileUpload;
  
  /**
   * ID of YT video
   */
  videoUrl?: string;
  
  /**
   * Sorting order position
   */
  rank: number;
}

/**
 * Needed for graphql multipart upload to work
 */
export type GQLFileUpload = any;

/**
 * Defines types of image which are supported by the backend
 */
export enum GQLImageType {
  GALLERY = 'GALLERY',
  FEATURED = 'FEATURED',
  LIST = 'LIST'
}

/**
 * ### Type for editing existing image
 */
export interface GQLImageUpdate {
  
  /**
   * Alt text of image
   */
  description?: string;
  
  /**
   * ID of YT video
   */
  videoUrl?: string;
  
  /**
   * Sorting order position
   */
  rank?: number;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new area
 */
export interface GQLAreaCreate {
  
  /**
   * UUID of destination where area belongs to
   */
  destinationId: string;
  
  /**
   * Element name
   */
  name: string;
  
  /**
   * Text used for introduction
   */
  excerpt?: string;
  
  /**
   * Text used as page source
   */
  content?: string;
  
  /**
   * Flag for marking area as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * Price for transfers
   */
  priceTransfer?: number;
  
  /**
   * UUID of currency in which are prices
   */
  currencyId: string;
}

/**
 * ### Type for updating existing area
 */
export interface GQLAreaUpdate {
  
  /**
   * UUID of destination where area belongs to
   */
  destinationId?: string;
  
  /**
   * Element name
   */
  name?: string;
  
  /**
   * Text used for introduction
   */
  excerpt?: string;
  
  /**
   * Text used as page source
   */
  content?: string;
  
  /**
   * Flag for marking area as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state?: GQLRecordState;
  
  /**
   * Price for transfers
   */
  priceTransfer?: number;
  
  /**
   * UUID of currency in which are prices
   */
  currencyId?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new hotel
 */
export interface GQLHotelCreate {
  
  /**
   * Name of the hotel
   */
  name: string;
  
  /**
   * Short introductional text
   */
  excerpt?: string;
  
  /**
   * Description, used as page source
   */
  content?: string;
  
  /**
   * Whether the hotel header should be dark
   */
  darkHeader?: boolean;
  
  /**
   * GPS coordinate of hotel position
   */
  latitude?: number;
  
  /**
   * GPS coordinate of hotel position
   */
  longitude?: number;
  
  /**
   * Distance to beach
   */
  distanceToBeach?: string;
  
  /**
   * UUID of HotelType
   */
  hotelTypeId: string;
  
  /**
   * UUID of area, where hotel belongs to
   */
  areaId: string;
  
  /**
   * Integration code for Juniper API
   */
  jpdCode?: string;
  
  /**
   * Integration code for old Elixir web
   */
  wpCode?: string;
  
  /**
   * Flag for marking hotel as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * Flag for hiding fly ticket price
   */
  hideFlyTicketPrice?: boolean;
  
  /**
   * Flag for hiding transfer price
   */
  hideTransferPrice?: boolean;
}

/**
 * ### Type for updating existing hotel
 */
export interface GQLHotelUpdate {
  
  /**
   * Name of the hotel
   */
  name?: string;
  
  /**
   * Short introductional text
   */
  excerpt?: string;
  
  /**
   * Description, used as page source
   */
  content?: string;
  
  /**
   * Whether the hotel header should be dark
   */
  darkHeader?: boolean;
  
  /**
   * GPS coordinate of hotel position
   */
  latitude?: number;
  
  /**
   * GPS coordinate of hotel position
   */
  longitude?: number;
  
  /**
   * Distance to beach
   */
  distanceToBeach?: string;
  
  /**
   * UUID of HotelType
   */
  hotelTypeId?: string;
  
  /**
   * UUID of area, where hotel belongs to
   */
  areaId?: string;
  
  /**
   * Integration code for Juniper API
   */
  jpdCode?: string;
  
  /**
   * Integration code for old Elixir web
   */
  wpCode?: string;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state?: GQLRecordState;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
  
  /**
   * Flag for hiding fly ticket price
   */
  hideFlyTicketPrice?: boolean;
  
  /**
   * Flag for hiding transfer price
   */
  hideTransferPrice?: boolean;
}

/**
 * ### Type for creating room
 */
export interface GQLRoomCreate {
  
  /**
   * UUID of hotel where room belongs to
   */
  hotelId: string;
  
  /**
   * Room name
   */
  name: string;
  
  /**
   * Short introductional text
   */
  excerpt?: string;
  
  /**
   * Room description
   */
  content?: string;
  
  /**
   * Area of room in square meters
   */
  area: number;
  
  /**
   * Flag for marking room as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
}

/**
 * ### Type for updating room
 */
export interface GQLRoomUpdate {
  
  /**
   * UUID of hotel where room belongs to
   */
  hotelId?: string;
  
  /**
   * Rootm name
   */
  name?: string;
  
  /**
   * Short introductional text
   */
  excerpt?: string;
  
  /**
   * Room description
   */
  content?: string;
  
  /**
   * Area of room in square meters
   */
  area?: number;
  
  /**
   * Flag for marking room as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state?: GQLRecordState;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new occupancy
 */
export interface GQLCreateOccupancy {
  
  /**
   * UUID of room, where occupancy belongs to
   */
  roomId: string;
  
  /**
   * Occupancy name
   */
  name: string;
  
  /**
   * Number of adults
   */
  adult: number;
  
  /**
   * Number of kids
   */
  child: number;
  
  /**
   * Extra bed in room possible
   */
  extraBed: boolean;
}

/**
 * ### Type for updating existing occupancy
 */
export interface GQLUpdateOccupancy {
  
  /**
   * UUID of room, where occupancy belongs to
   */
  roomId?: string;
  
  /**
   * Occupancy name
   */
  name?: string;
  
  /**
   * Number of adults
   */
  adult?: number;
  
  /**
   * Number of kids
   */
  child?: number;
  
  /**
   * Maximium of kids
   */
  maxChild?: number;
  
  /**
   * Extra bed in room possible
   */
  extraBed?: boolean;
}

/**
 * ### Type for creating new beach
 */
export interface GQLBeachCreate {
  
  /**
   * ID of area, where beach belongs to
   */
  areaId: string;
  
  /**
   * Beach name
   */
  name: string;
  
  /**
   * Beach intro text
   */
  excerpt?: string;
  
  /**
   * Beach description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * SEO description
   */
  description?: string;
}

/**
 * ### Type for updating exiting beach
 */
export interface GQLBeachUpdate {
  
  /**
   * ID of area, where beach belongs to
   */
  areaId?: string;
  
  /**
   * Beach name
   */
  name?: string;
  
  /**
   * Beach intro text
   */
  excerpt?: string;
  
  /**
   * Beach description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking beach as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state?: GQLRecordState;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating package
 */
export interface GQLPackageCreate {
  
  /**
   * UUID of board type
   */
  boardId: string;
  
  /**
   * UUID of currency in which are prices
   */
  currencyId: string;
  
  /**
   * Package description
   */
  description?: string;
  
  /**
   * If package is featured
   */
  featured: boolean;
  
  /**
   * Package name
   */
  name: string;
  
  /**
   * Number of nights for which the package is optimized
   */
  numberOfNights: number;
  
  /**
   * UUID of occupancy where package applies
   */
  occupancyId: string;
  
  /**
   * Price for accomodation
   */
  priceAccommodation: number;
  
  /**
   * Price for fly tickets
   */
  priceFlyTicket?: number;
  
  /**
   * Price for transfers
   */
  priceTransfer?: number;
  
  /**
   * Date from which the package can be shown to users
   */
  searchableFrom: GQLDateTime;
  
  /**
   * Date when the package becomes invisible to users
   */
  searchableTo: GQLDateTime;
  
  /**
   * Type of package
   */
  type: GQLPackageType;
  
  /**
   * Date from which is package valid
   */
  validFrom: GQLDateTime;
  
  /**
   * Date of package invalidation
   */
  validTo: GQLDateTime;
}

/**
 * ### Type for updating package
 */
export interface GQLPackageUpdate {
  
  /**
   * UUID of board type
   */
  boardId?: string;
  
  /**
   * UUID of currency in which are prices
   */
  currencyId?: string;
  
  /**
   * Package description
   */
  description?: string;
  
  /**
   * If package is featured
   */
  featured?: boolean;
  
  /**
   * Package name
   */
  name?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
  
  /**
   * UUID of board type
   */
  numberOfNights?: number;
  
  /**
   * UUID of occupancy where package applies
   */
  occupancyId?: string;
  
  /**
   * Price for accomodation
   */
  priceAccommodation?: number;
  
  /**
   * Price for fly tickets
   */
  priceFlyTicket?: number;
  
  /**
   * Price for transfers
   */
  priceTransfer?: number;
  
  /**
   * Date from which the package can be shown to users
   */
  searchableFrom?: GQLDateTime;
  
  /**
   * Date when the package becomes invisible to users
   */
  searchableTo?: GQLDateTime;
  
  /**
   * Type of package
   */
  type?: GQLPackageType;
  
  /**
   * Date from which is package valid
   */
  validFrom?: GQLDateTime;
  
  /**
   * Date too wchi is package valid
   */
  validTo?: GQLDateTime;
}

/**
 * ### Type for creating new hotel review
 */
export interface GQLHotelReviewCreate {
  
  /**
   * Review rating
   */
  rating: number;
  
  /**
   * Review description
   */
  description: string;
  
  /**
   * Author of review
   */
  author: string;
}

/**
 * ### Type for updating exisitng hotel review
 */
export interface GQLHotelReviewUpdate {
  
  /**
   * Review rating
   */
  rating?: number;
  
  /**
   * Review description
   */
  description?: string;
  
  /**
   * Author of review
   */
  author?: string;
}

/**
 * ### Type for creating new tag
 */
export interface GQLTagCreate {
  
  /**
   * Element name
   */
  name: string;
  
  /**
   * Element slug, if empty, then is automatically created from element name
   */
  slug?: string;
}

/**
 * ### Type for updating existing tag
 */
export interface GQLTagUpdate {
  
  /**
   * Element name
   */
  name?: string;
  
  /**
   * Element slug
   */
  slug?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new board
 */
export interface GQLBoardCreate {
  
  /**
   * Board name
   */
  name: string;
  
  /**
   * Weight used for custom sorting
   */
  rank: number;
}

/**
 * ### Type for updating existing board
 */
export interface GQLBoardUpdate {
  
  /**
   * Board name
   */
  name?: string;
  
  /**
   * Weight used for custom sorting
   */
  rank?: number;
}

/**
 * ### Type for creating new currency
 */
export interface GQLCurrencyCreate {
  
  /**
   * Internatinal currency code (ISO 4217)
   */
  code: string;
  
  /**
   * Currency name
   */
  name: string;
  
  /**
   * Amount of currency you get for the exchange
   */
  amount: number;
  
  /**
   * Exhange ratio - how much CZK you have to pay to get defined amount of currency
   */
  ratio: number;
}

/**
 * ### Type for updating existing currency
 */
export interface GQLCurrencyUpdate {
  
  /**
   * Internatinal currency code (ISO 4217)
   */
  code?: string;
  
  /**
   * Currency name
   */
  name?: string;
  
  /**
   * Amount of currency you get for 1 CZK when using exchange ratio
   */
  amount?: number;
  
  /**
   * Exhange ratio - how much CZK you have to pay to get defined amount of currency
   */
  ratio?: number;
}

/**
 * ### Type for creating new event
 */
export interface GQLEventCreate {
  
  /**
   * Event name
   */
  name: string;
  
  /**
   * Event slug, created from its name
   */
  slug?: string;
}

/**
 * ### Type for updating existing event
 */
export interface GQLEventUpdate {
  
  /**
   * Event name
   */
  name?: string;
  
  /**
   * Event slug, created from its name
   */
  slug?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new hotel type
 */
export interface GQLHotelTypeCreate {
  
  /**
   * Hotel type name
   */
  name: string;
  
  /**
   * Hotel type slug, created from its name
   */
  slug?: string;
  
  /**
   * Numeric representation of hotel type
   */
  stars: number;
}

/**
 * ### Type for updating existing hotel type
 */
export interface GQLHotelTypeUpdate {
  
  /**
   * Hotel type name
   */
  name?: string;
  
  /**
   * Hotel type slug, created from its name
   */
  slug?: string;
  
  /**
   * Numeric representation of hotel type
   */
  stars?: number;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new activity
 */
export interface GQLActivityCreate {
  
  /**
   * Activity name
   */
  name: string;
  
  /**
   * Activity intro text
   */
  excerpt?: string;
  
  /**
   * Activity description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking activity as featured on some lists
   */
  featured?: boolean;
}

/**
 * ### Type for updating existing activity
 */
export interface GQLActivityUpdate {
  
  /**
   * Activity name
   */
  name?: string;
  
  /**
   * Activity intro text
   */
  excerpt?: string;
  
  /**
   * Activity description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking activity as featured on some lists
   */
  featured?: boolean;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating new reference
 */
export interface GQLReferenceCreate {
  
  /**
   * Reference author name
   */
  author: string;
  
  /**
   * Text of reference
   */
  description: string;
  
  /**
   * Record state
   */
  state: GQLRecordState;
}

/**
 * ### Type for updating existing reference
 */
export interface GQLReferenceUpdate {
  
  /**
   * Reference author name
   */
  author?: string;
  
  /**
   * Text of reference
   */
  description?: string;
  
  /**
   * Record state
   */
  state?: GQLRecordState;
}

/**
 * ### Type for creating new article
 */
export interface GQLArticleCreate {
  
  /**
   * Element name
   */
  name: string;
  
  /**
   * Destination short introductional text
   */
  excerpt?: string;
  
  /**
   * Destination description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking destination as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state: GQLRecordState;
  
  /**
   * UUID of related destination
   */
  destinationId?: string;
  
  /**
   * UUID of related hotel
   */
  hotelId?: string;
  
  /**
   * SEO description
   */
  description?: string;
}

/**
 * ### Type for updating existinh article
 */
export interface GQLArticleUpdate {
  
  /**
   * Element name
   */
  name?: string;
  
  /**
   * Destination short introductional text
   */
  excerpt?: string;
  
  /**
   * Destination description, which is used to display as page text source
   */
  content?: string;
  
  /**
   * Flag for marking destination as featured on some lists
   */
  featured?: boolean;
  
  /**
   * State of record
   */
  state?: GQLRecordState;
  
  /**
   * UUID of related destination
   */
  destinationId?: string;
  
  /**
   * UUID of related hotel
   */
  hotelId?: string;
  
  /**
   * SEO description
   */
  description?: string;
  
  /**
   * List of fields that will be set to NULL value
   */
  nullables?: Array<string>;
}

/**
 * ### Type for creating/saving settings
 */
export interface GQLSaveSetting {
  
  /**
   * Name of the parameter
   */
  parameterName: string;
  
  /**
   * Value of parameter
   */
  parameterValue: string;
}

/**
 * ### Special setting parameters
 */
export interface GQLDefinedSetting {
  promotedHotels?: Array<string>;
  destinationsInMenu?: Array<string>;
  socialNetworks?: Array<GQLSaveSocialNetwork>;
  hotelsCarousel?: Array<string>;
}

/**
 * ### Social network input type
 */
export interface GQLSaveSocialNetwork {
  network: string;
  url: string;
}

/**
 * ### Vacation inquiry form
 */
export interface GQLInquiry {
  
  /**
   * Customer name and surname
   */
  name: string;
  
  /**
   * Customer e-mail address
   */
  mail: string;
  
  /**
   * Selected package
   */
  packageId?: string;
  
  /**
   * Customer telephone number
   */
  phone: string;
  
  /**
   * ID of selected destination
   */
  destinationId: string;
  
  /**
   * ID of selected hotel
   */
  hotelId: string;
  
  /**
   * Requested date from
   */
  from: GQLDateTime;
  
  /**
   * Requested date to
   */
  to: GQLDateTime;
  
  /**
   * Range of the requested nights the user wants to inquire for
   */
  numberOfNights: string;
  
  /**
   * Customer message to seller
   */
  message: string;
  
  /**
   * Google recaptcha token
   */
  token: string;
}

/**
 * ### Tailored offer form
 */
export interface GQLTailoredOffer {
  
  /**
   * Customer name and surname
   */
  name: string;
  
  /**
   * Customer e-mail address
   */
  email: string;
  
  /**
   * Customer telephone number
   */
  phone: string;
  
  /**
   * Requested date from
   */
  from: GQLDateTime;
  
  /**
   * Requested date to
   */
  to: GQLDateTime;
  
  /**
   * Range of the requested nights the user wants to inquire for
   */
  numberOfNights: string;
  
  /**
   * ID of selected destination
   */
  destinationIds: Array<string>;
  
  /**
   * Number of adults
   */
  adults: number;
  
  /**
   * Number of children
   */
  children: number;
  
  /**
   * Maximum budget
   */
  budget?: number;
  
  /**
   * Customer message to seller
   */
  message?: string;
  
  /**
   * Google recaptcha token
   */
  token: string;
}

/**
 * ### Contact form
 */
export interface GQLContact {
  
  /**
   * Customer e-mail address
   */
  mail: string;
  
  /**
   * Message subject
   */
  subject: string;
  
  /**
   * Customer message to seller
   */
  message: string;
  
  /**
   * Google recaptcha token
   */
  token: string;
}

/*********************************
 *                               *
 *         TYPE RESOLVERS        *
 *                               *
 *********************************/
/**
 * This interface define the shape of your resolver
 * Note that this type is designed to be compatible with graphql-tools resolvers
 * However, you can still use other generated interfaces to make your resolver type-safed
 */
export interface GQLResolver {
  RootQuery?: GQLRootQueryTypeResolver;
  Destinations?: GQLDestinationsTypeResolver;
  DestinationConnection?: GQLDestinationConnectionTypeResolver;
  Connection?: {
    __resolveType: GQLConnectionTypeResolver
  };
  
  PageInfo?: GQLPageInfoTypeResolver;
  DestinationEdge?: GQLDestinationEdgeTypeResolver;
  Edge?: {
    __resolveType: GQLEdgeTypeResolver
  };
  
  Destination?: GQLDestinationTypeResolver;
  Node?: {
    __resolveType: GQLNodeTypeResolver
  };
  
  Image?: GQLImageTypeResolver;
  DateTime?: GraphQLScalarType;
  ImageFormat?: GQLImageFormatTypeResolver;
  AreaConnection?: GQLAreaConnectionTypeResolver;
  AreaEdge?: GQLAreaEdgeTypeResolver;
  Area?: GQLAreaTypeResolver;
  BeachConnection?: GQLBeachConnectionTypeResolver;
  BeachEdge?: GQLBeachEdgeTypeResolver;
  Beach?: GQLBeachTypeResolver;
  BeachInterface?: {
    __resolveType: GQLBeachInterfaceTypeResolver
  };
  
  Slug?: GQLSlugTypeResolver;
  HotelConnection?: GQLHotelConnectionTypeResolver;
  HotelEdge?: GQLHotelEdgeTypeResolver;
  Hotel?: GQLHotelTypeResolver;
  HotelType?: GQLHotelTypeTypeResolver;
  HotelBeach?: GQLHotelBeachTypeResolver;
  Tag?: GQLTagTypeResolver;
  Activity?: GQLActivityTypeResolver;
  Event?: GQLEventTypeResolver;
  HotelReview?: GQLHotelReviewTypeResolver;
  Room?: GQLRoomTypeResolver;
  Occupancy?: GQLOccupancyTypeResolver;
  PackageConnection?: GQLPackageConnectionTypeResolver;
  PackageEdge?: GQLPackageEdgeTypeResolver;
  Package?: GQLPackageTypeResolver;
  Board?: GQLBoardTypeResolver;
  Price?: GQLPriceTypeResolver;
  Currency?: GQLCurrencyTypeResolver;
  CurrencyHistory?: GQLCurrencyHistoryTypeResolver;
  Article?: GQLArticleTypeResolver;
  Areas?: GQLAreasTypeResolver;
  Boards?: GQLBoardsTypeResolver;
  Currencies?: GQLCurrenciesTypeResolver;
  Tags?: GQLTagsTypeResolver;
  Activities?: GQLActivitiesTypeResolver;
  ActivityConnection?: GQLActivityConnectionTypeResolver;
  ActivityEdge?: GQLActivityEdgeTypeResolver;
  Beaches?: GQLBeachesTypeResolver;
  HotelTypes?: GQLHotelTypesTypeResolver;
  Events?: GQLEventsTypeResolver;
  EventConnection?: GQLEventConnectionTypeResolver;
  EventEdge?: GQLEventEdgeTypeResolver;
  Hotels?: GQLHotelsTypeResolver;
  ElixirServices?: GQLElixirServicesTypeResolver;
  ElixirService?: GQLElixirServiceTypeResolver;
  ElixirBeaches?: GQLElixirBeachesTypeResolver;
  ElixirBeach?: GQLElixirBeachTypeResolver;
  ElixirHotels?: GQLElixirHotelsTypeResolver;
  ElixirHotel?: GQLElixirHotelTypeResolver;
  ElixirCategory?: GQLElixirCategoryTypeResolver;
  ElixirBoard?: GQLElixirBoardTypeResolver;
  ElixirActivity?: GQLElixirActivityTypeResolver;
  ElixirIsland?: GQLElixirIslandTypeResolver;
  ElixirCapacity?: GQLElixirCapacityTypeResolver;
  ElixirImage?: GQLElixirImageTypeResolver;
  ElixirRoom?: GQLElixirRoomTypeResolver;
  ElixirPackage?: GQLElixirPackageTypeResolver;
  ElixirPrice?: GQLElixirPriceTypeResolver;
  ElixirHotelInventory?: GQLElixirHotelInventoryTypeResolver;
  JuniperHotels?: GQLJuniperHotelsTypeResolver;
  JuniperHotelList?: GQLJuniperHotelListTypeResolver;
  JuniperHotel?: GQLJuniperHotelTypeResolver;
  JuniperHotelCategory?: GQLJuniperHotelCategoryTypeResolver;
  JuniperHotelAddress?: GQLJuniperHotelAddressTypeResolver;
  JuniperCity?: GQLJuniperCityTypeResolver;
  JuniperCoordinates?: GQLJuniperCoordinatesTypeResolver;
  JuniperHotelRoom?: GQLJuniperHotelRoomTypeResolver;
  JuniperOccupancy?: GQLJuniperOccupancyTypeResolver;
  JuniperDescription?: GQLJuniperDescriptionTypeResolver;
  JuniperBoard?: GQLJuniperBoardTypeResolver;
  JuniperPaymentCard?: GQLJuniperPaymentCardTypeResolver;
  JuniperFeature?: GQLJuniperFeatureTypeResolver;
  JuniperRoomCategory?: GQLJuniperRoomCategoryTypeResolver;
  Newsletters?: GQLNewslettersTypeResolver;
  Newsletter?: GQLNewsletterTypeResolver;
  References?: GQLReferencesTypeResolver;
  Reference?: GQLReferenceTypeResolver;
  Routes?: GQLRoutesTypeResolver;
  RouteResult?: {
    __resolveType: GQLRouteResultTypeResolver
  };
  
  Packages?: GQLPackagesTypeResolver;
  Settings?: GQLSettingsTypeResolver;
  Setting?: GQLSettingTypeResolver;
  SocialNetwork?: GQLSocialNetworkTypeResolver;
  Search?: GQLSearchTypeResolver;
  SearchVacancyConnection?: GQLSearchVacancyConnectionTypeResolver;
  SearchVacancyEdge?: GQLSearchVacancyEdgeTypeResolver;
  SearchVacancy?: GQLSearchVacancyTypeResolver;
  SearchHotelConnection?: GQLSearchHotelConnectionTypeResolver;
  SearchHotelEdge?: GQLSearchHotelEdgeTypeResolver;
  Users?: GQLUsersTypeResolver;
  CurrentLogin?: GQLCurrentLoginTypeResolver;
  User?: GQLUserTypeResolver;
  Login?: GQLLoginTypeResolver;
  RootMutation?: GQLRootMutationTypeResolver;
  FileUpload?: GraphQLScalarType;
}
export interface GQLRootQueryTypeResolver<TParent = any> {
  destinations?: RootQueryToDestinationsResolver<TParent>;
  areas?: RootQueryToAreasResolver<TParent>;
  boards?: RootQueryToBoardsResolver<TParent>;
  currencies?: RootQueryToCurrenciesResolver<TParent>;
  tags?: RootQueryToTagsResolver<TParent>;
  activities?: RootQueryToActivitiesResolver<TParent>;
  beaches?: RootQueryToBeachesResolver<TParent>;
  hotelTypes?: RootQueryToHotelTypesResolver<TParent>;
  events?: RootQueryToEventsResolver<TParent>;
  hotels?: RootQueryToHotelsResolver<TParent>;
  elixirServices?: RootQueryToElixirServicesResolver<TParent>;
  elixirBeaches?: RootQueryToElixirBeachesResolver<TParent>;
  elixirHotels?: RootQueryToElixirHotelsResolver<TParent>;
  juniperHotels?: RootQueryToJuniperHotelsResolver<TParent>;
  newsletters?: RootQueryToNewslettersResolver<TParent>;
  references?: RootQueryToReferencesResolver<TParent>;
  routes?: RootQueryToRoutesResolver<TParent>;
  packages?: RootQueryToPackagesResolver<TParent>;
  settings?: RootQueryToSettingsResolver<TParent>;
  search?: RootQueryToSearchResolver<TParent>;
  users?: RootQueryToUsersResolver<TParent>;
}

export interface RootQueryToDestinationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToAreasResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToBoardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToCurrenciesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToTagsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToBeachesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToHotelTypesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToElixirServicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToElixirBeachesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToElixirHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToJuniperHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToNewslettersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToReferencesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToRoutesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToPackagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToSearchResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootQueryToUsersResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDestinationsTypeResolver<TParent = any> {
  list?: DestinationsToListResolver<TParent>;
  get?: DestinationsToGetResolver<TParent>;
  getBySlug?: DestinationsToGetBySlugResolver<TParent>;
  inMenu?: DestinationsToInMenuResolver<TParent>;
}

export interface DestinationsToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  selector?: GQLDestinationSelector;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface DestinationsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationsToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationsToGetArgs {
  id: string;
}
export interface DestinationsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationsToGetBySlugArgs {
  slug: string;
}
export interface DestinationsToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationsToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationsToInMenuArgs {
  visibility?: GQLVisibility;
}
export interface DestinationsToInMenuResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationsToInMenuArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDestinationConnectionTypeResolver<TParent = any> {
  edges?: DestinationConnectionToEdgesResolver<TParent>;
  pageInfo?: DestinationConnectionToPageInfoResolver<TParent>;
  totalCount?: DestinationConnectionToTotalCountResolver<TParent>;
}

export interface DestinationConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLConnectionTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'DestinationConnection' | 'AreaConnection' | 'BeachConnection' | 'HotelConnection' | 'PackageConnection' | 'ActivityConnection' | 'EventConnection' | 'SearchVacancyConnection' | 'SearchHotelConnection';
}
export interface GQLPageInfoTypeResolver<TParent = any> {
  hasNextPage?: PageInfoToHasNextPageResolver<TParent>;
  hasPreviousPage?: PageInfoToHasPreviousPageResolver<TParent>;
  startCursor?: PageInfoToStartCursorResolver<TParent>;
  endCursor?: PageInfoToEndCursorResolver<TParent>;
}

export interface PageInfoToHasNextPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToHasPreviousPageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToStartCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PageInfoToEndCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLDestinationEdgeTypeResolver<TParent = any> {
  node?: DestinationEdgeToNodeResolver<TParent>;
  cursor?: DestinationEdgeToCursorResolver<TParent>;
}

export interface DestinationEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEdgeTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'DestinationEdge' | 'AreaEdge' | 'BeachEdge' | 'HotelEdge' | 'PackageEdge' | 'ActivityEdge' | 'EventEdge' | 'SearchVacancyEdge' | 'SearchHotelEdge';
}
export interface GQLDestinationTypeResolver<TParent = any> {
  id?: DestinationToIdResolver<TParent>;
  name?: DestinationToNameResolver<TParent>;
  canonicalSlug?: DestinationToCanonicalSlugResolver<TParent>;
  excerpt?: DestinationToExcerptResolver<TParent>;
  content?: DestinationToContentResolver<TParent>;
  featured?: DestinationToFeaturedResolver<TParent>;
  mapImage?: DestinationToMapImageResolver<TParent>;
  areas?: DestinationToAreasResolver<TParent>;
  images?: DestinationToImagesResolver<TParent>;
  articles?: DestinationToArticlesResolver<TParent>;
  slugs?: DestinationToSlugsResolver<TParent>;
  featuredImage?: DestinationToFeaturedImageResolver<TParent>;
  listImage?: DestinationToListImageResolver<TParent>;
  state?: DestinationToStateResolver<TParent>;
  created?: DestinationToCreatedResolver<TParent>;
  lastModified?: DestinationToLastModifiedResolver<TParent>;
  description?: DestinationToDescriptionResolver<TParent>;
  priceFlyTicket?: DestinationToPriceFlyTicketResolver<TParent>;
  currency?: DestinationToCurrencyResolver<TParent>;
  hotels?: DestinationToHotelsResolver<TParent>;
}

export interface DestinationToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToCanonicalSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToMapImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToAreasArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface DestinationToAreasResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationToAreasArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToArticlesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToSlugsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToPriceFlyTicketArgs {
  currencyCode?: string;
}
export interface DestinationToPriceFlyTicketResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationToPriceFlyTicketArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface DestinationToHotelsArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  selector?: GQLHotelSelector;
  sort?: GQLHotelSort;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
  withAvailablePackages?: boolean;
}
export interface DestinationToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: DestinationToHotelsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNodeTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'Destination' | 'Area' | 'Beach' | 'Hotel' | 'Activity' | 'Event' | 'SearchVacancy';
}
export interface GQLImageTypeResolver<TParent = any> {
  id?: ImageToIdResolver<TParent>;
  path?: ImageToPathResolver<TParent>;
  description?: ImageToDescriptionResolver<TParent>;
  mimeType?: ImageToMimeTypeResolver<TParent>;
  videoUrl?: ImageToVideoUrlResolver<TParent>;
  fileSize?: ImageToFileSizeResolver<TParent>;
  width?: ImageToWidthResolver<TParent>;
  height?: ImageToHeightResolver<TParent>;
  src?: ImageToSrcResolver<TParent>;
  srcset?: ImageToSrcsetResolver<TParent>;
  rank?: ImageToRankResolver<TParent>;
  created?: ImageToCreatedResolver<TParent>;
  lastModified?: ImageToLastModifiedResolver<TParent>;
  formats?: ImageToFormatsResolver<TParent>;
}

export interface ImageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToMimeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToVideoUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToFileSizeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToWidthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToHeightResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToSrcResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToSrcsetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageToFormatsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLImageFormatTypeResolver<TParent = any> {
  path?: ImageFormatToPathResolver<TParent>;
  name?: ImageFormatToNameResolver<TParent>;
  width?: ImageFormatToWidthResolver<TParent>;
}

export interface ImageFormatToPathResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageFormatToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ImageFormatToWidthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAreaConnectionTypeResolver<TParent = any> {
  edges?: AreaConnectionToEdgesResolver<TParent>;
  pageInfo?: AreaConnectionToPageInfoResolver<TParent>;
  totalCount?: AreaConnectionToTotalCountResolver<TParent>;
}

export interface AreaConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAreaEdgeTypeResolver<TParent = any> {
  node?: AreaEdgeToNodeResolver<TParent>;
  cursor?: AreaEdgeToCursorResolver<TParent>;
}

export interface AreaEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAreaTypeResolver<TParent = any> {
  id?: AreaToIdResolver<TParent>;
  name?: AreaToNameResolver<TParent>;
  canonicalSlug?: AreaToCanonicalSlugResolver<TParent>;
  excerpt?: AreaToExcerptResolver<TParent>;
  content?: AreaToContentResolver<TParent>;
  destination?: AreaToDestinationResolver<TParent>;
  images?: AreaToImagesResolver<TParent>;
  beaches?: AreaToBeachesResolver<TParent>;
  hotels?: AreaToHotelsResolver<TParent>;
  jpdCode?: AreaToJpdCodeResolver<TParent>;
  slugs?: AreaToSlugsResolver<TParent>;
  featuredImage?: AreaToFeaturedImageResolver<TParent>;
  listImage?: AreaToListImageResolver<TParent>;
  featured?: AreaToFeaturedResolver<TParent>;
  state?: AreaToStateResolver<TParent>;
  created?: AreaToCreatedResolver<TParent>;
  lastModified?: AreaToLastModifiedResolver<TParent>;
  priceTransfer?: AreaToPriceTransferResolver<TParent>;
  currency?: AreaToCurrencyResolver<TParent>;
}

export interface AreaToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToCanonicalSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToDestinationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToBeachesArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
}
export interface AreaToBeachesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AreaToBeachesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToHotelsArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface AreaToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AreaToHotelsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToJpdCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToSlugsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToPriceTransferArgs {
  currencyCode?: string;
}
export interface AreaToPriceTransferResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AreaToPriceTransferArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreaToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBeachConnectionTypeResolver<TParent = any> {
  edges?: BeachConnectionToEdgesResolver<TParent>;
  pageInfo?: BeachConnectionToPageInfoResolver<TParent>;
  totalCount?: BeachConnectionToTotalCountResolver<TParent>;
}

export interface BeachConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBeachEdgeTypeResolver<TParent = any> {
  node?: BeachEdgeToNodeResolver<TParent>;
  cursor?: BeachEdgeToCursorResolver<TParent>;
}

export interface BeachEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBeachTypeResolver<TParent = any> {
  id?: BeachToIdResolver<TParent>;
  name?: BeachToNameResolver<TParent>;
  canonicalSlug?: BeachToCanonicalSlugResolver<TParent>;
  excerpt?: BeachToExcerptResolver<TParent>;
  content?: BeachToContentResolver<TParent>;
  area?: BeachToAreaResolver<TParent>;
  images?: BeachToImagesResolver<TParent>;
  slugs?: BeachToSlugsResolver<TParent>;
  featuredImage?: BeachToFeaturedImageResolver<TParent>;
  listImage?: BeachToListImageResolver<TParent>;
  featured?: BeachToFeaturedResolver<TParent>;
  state?: BeachToStateResolver<TParent>;
  hotels?: BeachToHotelsResolver<TParent>;
  created?: BeachToCreatedResolver<TParent>;
  lastModified?: BeachToLastModifiedResolver<TParent>;
  description?: BeachToDescriptionResolver<TParent>;
}

export interface BeachToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToCanonicalSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToSlugsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToHotelsArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
}
export interface BeachToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BeachToHotelsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBeachInterfaceTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'Beach' | 'HotelBeach';
}
export interface GQLSlugTypeResolver<TParent = any> {
  id?: SlugToIdResolver<TParent>;
  slug?: SlugToSlugResolver<TParent>;
  canonical?: SlugToCanonicalResolver<TParent>;
  created?: SlugToCreatedResolver<TParent>;
  lastModified?: SlugToLastModifiedResolver<TParent>;
}

export interface SlugToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlugToSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlugToCanonicalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlugToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SlugToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelConnectionTypeResolver<TParent = any> {
  edges?: HotelConnectionToEdgesResolver<TParent>;
  pageInfo?: HotelConnectionToPageInfoResolver<TParent>;
  totalCount?: HotelConnectionToTotalCountResolver<TParent>;
}

export interface HotelConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelEdgeTypeResolver<TParent = any> {
  node?: HotelEdgeToNodeResolver<TParent>;
  cursor?: HotelEdgeToCursorResolver<TParent>;
}

export interface HotelEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelTypeResolver<TParent = any> {
  id?: HotelToIdResolver<TParent>;
  name?: HotelToNameResolver<TParent>;
  canonicalSlug?: HotelToCanonicalSlugResolver<TParent>;
  darkHeader?: HotelToDarkHeaderResolver<TParent>;
  excerpt?: HotelToExcerptResolver<TParent>;
  content?: HotelToContentResolver<TParent>;
  latitude?: HotelToLatitudeResolver<TParent>;
  longitude?: HotelToLongitudeResolver<TParent>;
  distanceToBeach?: HotelToDistanceToBeachResolver<TParent>;
  hotelType?: HotelToHotelTypeResolver<TParent>;
  area?: HotelToAreaResolver<TParent>;
  beaches?: HotelToBeachesResolver<TParent>;
  tags?: HotelToTagsResolver<TParent>;
  activities?: HotelToActivitiesResolver<TParent>;
  events?: HotelToEventsResolver<TParent>;
  images?: HotelToImagesResolver<TParent>;
  reviews?: HotelToReviewsResolver<TParent>;
  averageRating?: HotelToAverageRatingResolver<TParent>;
  jpdCode?: HotelToJpdCodeResolver<TParent>;
  wpCode?: HotelToWpCodeResolver<TParent>;
  rooms?: HotelToRoomsResolver<TParent>;
  slugs?: HotelToSlugsResolver<TParent>;
  featuredImage?: HotelToFeaturedImageResolver<TParent>;
  listImage?: HotelToListImageResolver<TParent>;
  featured?: HotelToFeaturedResolver<TParent>;
  state?: HotelToStateResolver<TParent>;
  articles?: HotelToArticlesResolver<TParent>;
  created?: HotelToCreatedResolver<TParent>;
  lastModified?: HotelToLastModifiedResolver<TParent>;
  description?: HotelToDescriptionResolver<TParent>;
  promoPackage?: HotelToPromoPackageResolver<TParent>;
  hideFlyTicketPrice?: HotelToHideFlyTicketPriceResolver<TParent>;
  hideTransferPrice?: HotelToHideTransferPriceResolver<TParent>;
  priceFrom?: HotelToPriceFromResolver<TParent>;
  boards?: HotelToBoardsResolver<TParent>;
}

export interface HotelToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToCanonicalSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToDarkHeaderResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToLatitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToLongitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToDistanceToBeachResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToHotelTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToBeachesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToTagsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToEventsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToReviewsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToAverageRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToJpdCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToWpCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToRoomsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToSlugsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToArticlesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToPromoPackageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToHideFlyTicketPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToHideTransferPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToPriceFromArgs {
  currencyCode?: string;
}
export interface HotelToPriceFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelToPriceFromArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelToBoardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelTypeTypeResolver<TParent = any> {
  id?: HotelTypeToIdResolver<TParent>;
  name?: HotelTypeToNameResolver<TParent>;
  slug?: HotelTypeToSlugResolver<TParent>;
  stars?: HotelTypeToStarsResolver<TParent>;
  created?: HotelTypeToCreatedResolver<TParent>;
  lastModified?: HotelTypeToLastModifiedResolver<TParent>;
  hotels?: HotelTypeToHotelsResolver<TParent>;
}

export interface HotelTypeToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypeToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypeToSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypeToStarsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypeToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypeToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypeToHotelsArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
}
export interface HotelTypeToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelTypeToHotelsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelBeachTypeResolver<TParent = any> {
  nextToHotel?: HotelBeachToNextToHotelResolver<TParent>;
  id?: HotelBeachToIdResolver<TParent>;
  name?: HotelBeachToNameResolver<TParent>;
  canonicalSlug?: HotelBeachToCanonicalSlugResolver<TParent>;
  excerpt?: HotelBeachToExcerptResolver<TParent>;
  content?: HotelBeachToContentResolver<TParent>;
  area?: HotelBeachToAreaResolver<TParent>;
  images?: HotelBeachToImagesResolver<TParent>;
  slugs?: HotelBeachToSlugsResolver<TParent>;
  featuredImage?: HotelBeachToFeaturedImageResolver<TParent>;
  listImage?: HotelBeachToListImageResolver<TParent>;
  featured?: HotelBeachToFeaturedResolver<TParent>;
  state?: HotelBeachToStateResolver<TParent>;
  hotels?: HotelBeachToHotelsResolver<TParent>;
  created?: HotelBeachToCreatedResolver<TParent>;
  lastModified?: HotelBeachToLastModifiedResolver<TParent>;
  description?: HotelBeachToDescriptionResolver<TParent>;
}

export interface HotelBeachToNextToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToCanonicalSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToSlugsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToHotelsArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
}
export interface HotelBeachToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelBeachToHotelsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelBeachToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTagTypeResolver<TParent = any> {
  id?: TagToIdResolver<TParent>;
  name?: TagToNameResolver<TParent>;
  slug?: TagToSlugResolver<TParent>;
  created?: TagToCreatedResolver<TParent>;
  lastModified?: TagToLastModifiedResolver<TParent>;
}

export interface TagToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagToSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActivityTypeResolver<TParent = any> {
  id?: ActivityToIdResolver<TParent>;
  name?: ActivityToNameResolver<TParent>;
  excerpt?: ActivityToExcerptResolver<TParent>;
  content?: ActivityToContentResolver<TParent>;
  featured?: ActivityToFeaturedResolver<TParent>;
  created?: ActivityToCreatedResolver<TParent>;
  lastModified?: ActivityToLastModifiedResolver<TParent>;
  listImage?: ActivityToListImageResolver<TParent>;
}

export interface ActivityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventTypeResolver<TParent = any> {
  id?: EventToIdResolver<TParent>;
  name?: EventToNameResolver<TParent>;
  slug?: EventToSlugResolver<TParent>;
  created?: EventToCreatedResolver<TParent>;
  lastModified?: EventToLastModifiedResolver<TParent>;
}

export interface EventToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelReviewTypeResolver<TParent = any> {
  id?: HotelReviewToIdResolver<TParent>;
  hotel?: HotelReviewToHotelResolver<TParent>;
  rating?: HotelReviewToRatingResolver<TParent>;
  description?: HotelReviewToDescriptionResolver<TParent>;
  author?: HotelReviewToAuthorResolver<TParent>;
  created?: HotelReviewToCreatedResolver<TParent>;
  lastModified?: HotelReviewToLastModifiedResolver<TParent>;
}

export interface HotelReviewToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelReviewToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelReviewToRatingResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelReviewToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelReviewToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelReviewToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelReviewToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoomTypeResolver<TParent = any> {
  id?: RoomToIdResolver<TParent>;
  hotel?: RoomToHotelResolver<TParent>;
  name?: RoomToNameResolver<TParent>;
  excerpt?: RoomToExcerptResolver<TParent>;
  content?: RoomToContentResolver<TParent>;
  area?: RoomToAreaResolver<TParent>;
  featured?: RoomToFeaturedResolver<TParent>;
  state?: RoomToStateResolver<TParent>;
  created?: RoomToCreatedResolver<TParent>;
  lastModified?: RoomToLastModifiedResolver<TParent>;
  images?: RoomToImagesResolver<TParent>;
  occupancies?: RoomToOccupanciesResolver<TParent>;
}

export interface RoomToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RoomToOccupanciesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLOccupancyTypeResolver<TParent = any> {
  id?: OccupancyToIdResolver<TParent>;
  room?: OccupancyToRoomResolver<TParent>;
  name?: OccupancyToNameResolver<TParent>;
  adult?: OccupancyToAdultResolver<TParent>;
  child?: OccupancyToChildResolver<TParent>;
  extraBed?: OccupancyToExtraBedResolver<TParent>;
  packages?: OccupancyToPackagesResolver<TParent>;
}

export interface OccupancyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OccupancyToRoomResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OccupancyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OccupancyToAdultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OccupancyToChildResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OccupancyToExtraBedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface OccupancyToPackagesArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  selector?: GQLPackageSelector;
  sort?: GQLPackageSort;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface OccupancyToPackagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: OccupancyToPackagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPackageConnectionTypeResolver<TParent = any> {
  edges?: PackageConnectionToEdgesResolver<TParent>;
  pageInfo?: PackageConnectionToPageInfoResolver<TParent>;
  totalCount?: PackageConnectionToTotalCountResolver<TParent>;
}

export interface PackageConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPackageEdgeTypeResolver<TParent = any> {
  node?: PackageEdgeToNodeResolver<TParent>;
  cursor?: PackageEdgeToCursorResolver<TParent>;
}

export interface PackageEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPackageTypeResolver<TParent = any> {
  id?: PackageToIdResolver<TParent>;
  occupancy?: PackageToOccupancyResolver<TParent>;
  name?: PackageToNameResolver<TParent>;
  description?: PackageToDescriptionResolver<TParent>;
  type?: PackageToTypeResolver<TParent>;
  board?: PackageToBoardResolver<TParent>;
  numberOfNights?: PackageToNumberOfNightsResolver<TParent>;
  validFrom?: PackageToValidFromResolver<TParent>;
  validTo?: PackageToValidToResolver<TParent>;
  priceAccommodation?: PackageToPriceAccommodationResolver<TParent>;
  priceTransfer?: PackageToPriceTransferResolver<TParent>;
  priceFlyTicket?: PackageToPriceFlyTicketResolver<TParent>;
  priceTotal?: PackageToPriceTotalResolver<TParent>;
  searchableFrom?: PackageToSearchableFromResolver<TParent>;
  searchableTo?: PackageToSearchableToResolver<TParent>;
  currency?: PackageToCurrencyResolver<TParent>;
  featured?: PackageToFeaturedResolver<TParent>;
  created?: PackageToCreatedResolver<TParent>;
  lastModified?: PackageToLastModifiedResolver<TParent>;
}

export interface PackageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToOccupancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToBoardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToNumberOfNightsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToValidFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToValidToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToPriceAccommodationArgs {
  currencyCode?: string;
}
export interface PackageToPriceAccommodationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PackageToPriceAccommodationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToPriceTransferArgs {
  currencyCode?: string;
}
export interface PackageToPriceTransferResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PackageToPriceTransferArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToPriceFlyTicketArgs {
  currencyCode?: string;
}
export interface PackageToPriceFlyTicketResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PackageToPriceFlyTicketArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToPriceTotalArgs {
  currencyCode?: string;
}
export interface PackageToPriceTotalResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PackageToPriceTotalArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToSearchableFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToSearchableToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PackageToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBoardTypeResolver<TParent = any> {
  id?: BoardToIdResolver<TParent>;
  name?: BoardToNameResolver<TParent>;
  rank?: BoardToRankResolver<TParent>;
  created?: BoardToCreatedResolver<TParent>;
  lastModified?: BoardToLastModifiedResolver<TParent>;
}

export interface BoardToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BoardToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BoardToRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BoardToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BoardToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLPriceTypeResolver<TParent = any> {
  amount?: PriceToAmountResolver<TParent>;
  currency?: PriceToCurrencyResolver<TParent>;
}

export interface PriceToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface PriceToCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrencyTypeResolver<TParent = any> {
  id?: CurrencyToIdResolver<TParent>;
  code?: CurrencyToCodeResolver<TParent>;
  name?: CurrencyToNameResolver<TParent>;
  amount?: CurrencyToAmountResolver<TParent>;
  ratio?: CurrencyToRatioResolver<TParent>;
  history?: CurrencyToHistoryResolver<TParent>;
  created?: CurrencyToCreatedResolver<TParent>;
  lastModified?: CurrencyToLastModifiedResolver<TParent>;
}

export interface CurrencyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToAmountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToRatioResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToHistoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrencyHistoryTypeResolver<TParent = any> {
  id?: CurrencyHistoryToIdResolver<TParent>;
  ratio?: CurrencyHistoryToRatioResolver<TParent>;
  variance?: CurrencyHistoryToVarianceResolver<TParent>;
  created?: CurrencyHistoryToCreatedResolver<TParent>;
  lastModified?: CurrencyHistoryToLastModifiedResolver<TParent>;
}

export interface CurrencyHistoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyHistoryToRatioResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyHistoryToVarianceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyHistoryToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrencyHistoryToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLArticleTypeResolver<TParent = any> {
  id?: ArticleToIdResolver<TParent>;
  name?: ArticleToNameResolver<TParent>;
  canonicalSlug?: ArticleToCanonicalSlugResolver<TParent>;
  excerpt?: ArticleToExcerptResolver<TParent>;
  content?: ArticleToContentResolver<TParent>;
  featured?: ArticleToFeaturedResolver<TParent>;
  state?: ArticleToStateResolver<TParent>;
  slugs?: ArticleToSlugsResolver<TParent>;
  featuredImage?: ArticleToFeaturedImageResolver<TParent>;
  listImage?: ArticleToListImageResolver<TParent>;
  destinations?: ArticleToDestinationsResolver<TParent>;
  hotels?: ArticleToHotelsResolver<TParent>;
  created?: ArticleToCreatedResolver<TParent>;
  lastModified?: ArticleToLastModifiedResolver<TParent>;
  description?: ArticleToDescriptionResolver<TParent>;
}

export interface ArticleToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToCanonicalSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToFeaturedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToSlugsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToListImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToDestinationsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToHotelsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ArticleToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLAreasTypeResolver<TParent = any> {
  list?: AreasToListResolver<TParent>;
  get?: AreasToGetResolver<TParent>;
  getBySlug?: AreasToGetBySlugResolver<TParent>;
}

export interface AreasToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  selector?: GQLAreaSelector;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface AreasToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AreasToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreasToGetArgs {
  id: string;
}
export interface AreasToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AreasToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface AreasToGetBySlugArgs {
  slug: string;
}
export interface AreasToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: AreasToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBoardsTypeResolver<TParent = any> {
  list?: BoardsToListResolver<TParent>;
  get?: BoardsToGetResolver<TParent>;
}

export interface BoardsToListArgs {
  sortBy?: string;
  sortOrder?: string;
}
export interface BoardsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BoardsToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BoardsToGetArgs {
  id: string;
}
export interface BoardsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BoardsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrenciesTypeResolver<TParent = any> {
  list?: CurrenciesToListResolver<TParent>;
  get?: CurrenciesToGetResolver<TParent>;
}

export interface CurrenciesToListArgs {
  sortBy?: string;
  sortOrder?: string;
}
export interface CurrenciesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CurrenciesToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrenciesToGetArgs {
  id: string;
}
export interface CurrenciesToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: CurrenciesToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLTagsTypeResolver<TParent = any> {
  list?: TagsToListResolver<TParent>;
  get?: TagsToGetResolver<TParent>;
  getBySlug?: TagsToGetBySlugResolver<TParent>;
}

export interface TagsToListArgs {
  sortBy?: string;
  sortOrder?: string;
}
export interface TagsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: TagsToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagsToGetArgs {
  id: string;
}
export interface TagsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: TagsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface TagsToGetBySlugArgs {
  slug: string;
}
export interface TagsToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: TagsToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActivitiesTypeResolver<TParent = any> {
  list?: ActivitiesToListResolver<TParent>;
  get?: ActivitiesToGetResolver<TParent>;
}

export interface ActivitiesToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface ActivitiesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ActivitiesToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivitiesToGetArgs {
  id: string;
}
export interface ActivitiesToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ActivitiesToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActivityConnectionTypeResolver<TParent = any> {
  edges?: ActivityConnectionToEdgesResolver<TParent>;
  pageInfo?: ActivityConnectionToPageInfoResolver<TParent>;
  totalCount?: ActivityConnectionToTotalCountResolver<TParent>;
}

export interface ActivityConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLActivityEdgeTypeResolver<TParent = any> {
  node?: ActivityEdgeToNodeResolver<TParent>;
  cursor?: ActivityEdgeToCursorResolver<TParent>;
}

export interface ActivityEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ActivityEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLBeachesTypeResolver<TParent = any> {
  list?: BeachesToListResolver<TParent>;
  get?: BeachesToGetResolver<TParent>;
  getBySlug?: BeachesToGetBySlugResolver<TParent>;
}

export interface BeachesToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  selector?: GQLBeachSelector;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface BeachesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BeachesToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachesToGetArgs {
  id: string;
}
export interface BeachesToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BeachesToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface BeachesToGetBySlugArgs {
  slug: string;
}
export interface BeachesToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: BeachesToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelTypesTypeResolver<TParent = any> {
  list?: HotelTypesToListResolver<TParent>;
  get?: HotelTypesToGetResolver<TParent>;
  getBySlug?: HotelTypesToGetBySlugResolver<TParent>;
}

export interface HotelTypesToListArgs {
  sortBy?: string;
  sortOrder?: string;
}
export interface HotelTypesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelTypesToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypesToGetArgs {
  id: string;
}
export interface HotelTypesToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelTypesToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelTypesToGetBySlugArgs {
  slug: string;
}
export interface HotelTypesToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelTypesToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventsTypeResolver<TParent = any> {
  list?: EventsToListResolver<TParent>;
  get?: EventsToGetResolver<TParent>;
  getBySlug?: EventsToGetBySlugResolver<TParent>;
}

export interface EventsToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface EventsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventsToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventsToGetArgs {
  id: string;
}
export interface EventsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventsToGetBySlugArgs {
  slug: string;
}
export interface EventsToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: EventsToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventConnectionTypeResolver<TParent = any> {
  edges?: EventConnectionToEdgesResolver<TParent>;
  pageInfo?: EventConnectionToPageInfoResolver<TParent>;
  totalCount?: EventConnectionToTotalCountResolver<TParent>;
}

export interface EventConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLEventEdgeTypeResolver<TParent = any> {
  node?: EventEdgeToNodeResolver<TParent>;
  cursor?: EventEdgeToCursorResolver<TParent>;
}

export interface EventEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface EventEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLHotelsTypeResolver<TParent = any> {
  list?: HotelsToListResolver<TParent>;
  get?: HotelsToGetResolver<TParent>;
  getBySlug?: HotelsToGetBySlugResolver<TParent>;
  promoted?: HotelsToPromotedResolver<TParent>;
  carousel?: HotelsToCarouselResolver<TParent>;
}

export interface HotelsToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  selector?: GQLHotelSelector;
  sort?: GQLHotelSort;
  featuredFirst?: boolean;
  visibility?: GQLVisibility;
  not?: Array<string>;
}
export interface HotelsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelsToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelsToGetArgs {
  id: string;
}
export interface HotelsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelsToGetBySlugArgs {
  slug: string;
}
export interface HotelsToGetBySlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelsToGetBySlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelsToPromotedArgs {
  visibility?: GQLVisibility;
}
export interface HotelsToPromotedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelsToPromotedArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface HotelsToCarouselArgs {
  visibility?: GQLVisibility;
}
export interface HotelsToCarouselResolver<TParent = any, TResult = any> {
  (parent: TParent, args: HotelsToCarouselArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirServicesTypeResolver<TParent = any> {
  list?: ElixirServicesToListResolver<TParent>;
}

export interface ElixirServicesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirServiceTypeResolver<TParent = any> {
  id?: ElixirServiceToIdResolver<TParent>;
  title?: ElixirServiceToTitleResolver<TParent>;
  excerpt?: ElixirServiceToExcerptResolver<TParent>;
  lastModified?: ElixirServiceToLastModifiedResolver<TParent>;
  guid?: ElixirServiceToGuidResolver<TParent>;
  parentId?: ElixirServiceToParentIdResolver<TParent>;
}

export interface ElixirServiceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirServiceToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirServiceToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirServiceToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirServiceToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirServiceToParentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirBeachesTypeResolver<TParent = any> {
  list?: ElixirBeachesToListResolver<TParent>;
  get?: ElixirBeachesToGetResolver<TParent>;
}

export interface ElixirBeachesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachesToGetArgs {
  id: number;
}
export interface ElixirBeachesToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ElixirBeachesToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirBeachTypeResolver<TParent = any> {
  id?: ElixirBeachToIdResolver<TParent>;
  title?: ElixirBeachToTitleResolver<TParent>;
  content?: ElixirBeachToContentResolver<TParent>;
  excerpt?: ElixirBeachToExcerptResolver<TParent>;
  lastModified?: ElixirBeachToLastModifiedResolver<TParent>;
  guid?: ElixirBeachToGuidResolver<TParent>;
  parentId?: ElixirBeachToParentIdResolver<TParent>;
  videos?: ElixirBeachToVideosResolver<TParent>;
  latitude?: ElixirBeachToLatitudeResolver<TParent>;
  longitude?: ElixirBeachToLongitudeResolver<TParent>;
  services?: ElixirBeachToServicesResolver<TParent>;
}

export interface ElixirBeachToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToParentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToVideosResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToLatitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToLongitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBeachToServicesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirHotelsTypeResolver<TParent = any> {
  list?: ElixirHotelsToListResolver<TParent>;
  get?: ElixirHotelsToGetResolver<TParent>;
  inventory?: ElixirHotelsToInventoryResolver<TParent>;
}

export interface ElixirHotelsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelsToGetArgs {
  id?: number;
}
export interface ElixirHotelsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ElixirHotelsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelsToInventoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirHotelTypeResolver<TParent = any> {
  id?: ElixirHotelToIdResolver<TParent>;
  title?: ElixirHotelToTitleResolver<TParent>;
  content?: ElixirHotelToContentResolver<TParent>;
  excerpt?: ElixirHotelToExcerptResolver<TParent>;
  guid?: ElixirHotelToGuidResolver<TParent>;
  lastModified?: ElixirHotelToLastModifiedResolver<TParent>;
  featuredImage?: ElixirHotelToFeaturedImageResolver<TParent>;
  categories?: ElixirHotelToCategoriesResolver<TParent>;
  boards?: ElixirHotelToBoardsResolver<TParent>;
  activities?: ElixirHotelToActivitiesResolver<TParent>;
  islands?: ElixirHotelToIslandsResolver<TParent>;
  capacities?: ElixirHotelToCapacitiesResolver<TParent>;
  galleries?: ElixirHotelToGalleriesResolver<TParent>;
  rooms?: ElixirHotelToRoomsResolver<TParent>;
  prices?: ElixirHotelToPricesResolver<TParent>;
}

export interface ElixirHotelToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToFeaturedImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToCategoriesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToBoardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToActivitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToIslandsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToCapacitiesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToGalleriesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToRoomsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelToPricesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirCategoryTypeResolver<TParent = any> {
  id?: ElixirCategoryToIdResolver<TParent>;
  title?: ElixirCategoryToTitleResolver<TParent>;
  description?: ElixirCategoryToDescriptionResolver<TParent>;
}

export interface ElixirCategoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirCategoryToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirCategoryToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirBoardTypeResolver<TParent = any> {
  id?: ElixirBoardToIdResolver<TParent>;
  title?: ElixirBoardToTitleResolver<TParent>;
  description?: ElixirBoardToDescriptionResolver<TParent>;
}

export interface ElixirBoardToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBoardToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirBoardToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirActivityTypeResolver<TParent = any> {
  id?: ElixirActivityToIdResolver<TParent>;
  title?: ElixirActivityToTitleResolver<TParent>;
  excerpt?: ElixirActivityToExcerptResolver<TParent>;
  guid?: ElixirActivityToGuidResolver<TParent>;
  lastModified?: ElixirActivityToLastModifiedResolver<TParent>;
  parent?: ElixirActivityToParentResolver<TParent>;
}

export interface ElixirActivityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirActivityToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirActivityToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirActivityToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirActivityToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirActivityToParentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirIslandTypeResolver<TParent = any> {
  id?: ElixirIslandToIdResolver<TParent>;
  title?: ElixirIslandToTitleResolver<TParent>;
  description?: ElixirIslandToDescriptionResolver<TParent>;
  parentId?: ElixirIslandToParentIdResolver<TParent>;
}

export interface ElixirIslandToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirIslandToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirIslandToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirIslandToParentIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirCapacityTypeResolver<TParent = any> {
  id?: ElixirCapacityToIdResolver<TParent>;
  title?: ElixirCapacityToTitleResolver<TParent>;
  description?: ElixirCapacityToDescriptionResolver<TParent>;
}

export interface ElixirCapacityToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirCapacityToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirCapacityToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirImageTypeResolver<TParent = any> {
  id?: ElixirImageToIdResolver<TParent>;
  title?: ElixirImageToTitleResolver<TParent>;
  excerpt?: ElixirImageToExcerptResolver<TParent>;
  guid?: ElixirImageToGuidResolver<TParent>;
  lastModified?: ElixirImageToLastModifiedResolver<TParent>;
  parent?: ElixirImageToParentResolver<TParent>;
  mimeType?: ElixirImageToMimeTypeResolver<TParent>;
}

export interface ElixirImageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirImageToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirImageToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirImageToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirImageToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirImageToParentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirImageToMimeTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirRoomTypeResolver<TParent = any> {
  id?: ElixirRoomToIdResolver<TParent>;
  title?: ElixirRoomToTitleResolver<TParent>;
  content?: ElixirRoomToContentResolver<TParent>;
  excerpt?: ElixirRoomToExcerptResolver<TParent>;
  guid?: ElixirRoomToGuidResolver<TParent>;
  lastModified?: ElixirRoomToLastModifiedResolver<TParent>;
  galleries?: ElixirRoomToGalleriesResolver<TParent>;
  packages?: ElixirRoomToPackagesResolver<TParent>;
}

export interface ElixirRoomToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToContentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToGalleriesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirRoomToPackagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirPackageTypeResolver<TParent = any> {
  id?: ElixirPackageToIdResolver<TParent>;
  title?: ElixirPackageToTitleResolver<TParent>;
  excerpt?: ElixirPackageToExcerptResolver<TParent>;
  length?: ElixirPackageToLengthResolver<TParent>;
  board?: ElixirPackageToBoardResolver<TParent>;
  dateFrom?: ElixirPackageToDateFromResolver<TParent>;
  dateTo?: ElixirPackageToDateToResolver<TParent>;
  priceAccommodation?: ElixirPackageToPriceAccommodationResolver<TParent>;
  priceTransfer?: ElixirPackageToPriceTransferResolver<TParent>;
  priceFlight?: ElixirPackageToPriceFlightResolver<TParent>;
  guid?: ElixirPackageToGuidResolver<TParent>;
  lastModified?: ElixirPackageToLastModifiedResolver<TParent>;
}

export interface ElixirPackageToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToExcerptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToLengthResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToBoardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToDateFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToDateToResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToPriceAccommodationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToPriceTransferResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToPriceFlightResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToGuidResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPackageToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirPriceTypeResolver<TParent = any> {
  id?: ElixirPriceToIdResolver<TParent>;
  title?: ElixirPriceToTitleResolver<TParent>;
  description?: ElixirPriceToDescriptionResolver<TParent>;
}

export interface ElixirPriceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPriceToTitleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirPriceToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLElixirHotelInventoryTypeResolver<TParent = any> {
  id?: ElixirHotelInventoryToIdResolver<TParent>;
  name?: ElixirHotelInventoryToNameResolver<TParent>;
  imported?: ElixirHotelInventoryToImportedResolver<TParent>;
}

export interface ElixirHotelInventoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelInventoryToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ElixirHotelInventoryToImportedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperHotelsTypeResolver<TParent = any> {
  list?: JuniperHotelsToListResolver<TParent>;
  get?: JuniperHotelsToGetResolver<TParent>;
  roomCategoryList?: JuniperHotelsToRoomCategoryListResolver<TParent>;
}

export interface JuniperHotelsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelsToGetArgs {
  hotelCode: string;
}
export interface JuniperHotelsToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: JuniperHotelsToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelsToRoomCategoryListArgs {
  hotelCode: string;
}
export interface JuniperHotelsToRoomCategoryListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: JuniperHotelsToRoomCategoryListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperHotelListTypeResolver<TParent = any> {
  hotelCode?: JuniperHotelListToHotelCodeResolver<TParent>;
  name?: JuniperHotelListToNameResolver<TParent>;
  imported?: JuniperHotelListToImportedResolver<TParent>;
}

export interface JuniperHotelListToHotelCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelListToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelListToImportedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperHotelTypeResolver<TParent = any> {
  hotelCode?: JuniperHotelToHotelCodeResolver<TParent>;
  name?: JuniperHotelToNameResolver<TParent>;
  category?: JuniperHotelToCategoryResolver<TParent>;
  address?: JuniperHotelToAddressResolver<TParent>;
  roomTypes?: JuniperHotelToRoomTypesResolver<TParent>;
  boards?: JuniperHotelToBoardsResolver<TParent>;
  paymentCards?: JuniperHotelToPaymentCardsResolver<TParent>;
  features?: JuniperHotelToFeaturesResolver<TParent>;
  images?: JuniperHotelToImagesResolver<TParent>;
  hotelCodeEncrypt?: JuniperHotelToHotelCodeEncryptResolver<TParent>;
  shortDescription?: JuniperHotelToShortDescriptionResolver<TParent>;
  longDescription?: JuniperHotelToLongDescriptionResolver<TParent>;
}

export interface JuniperHotelToHotelCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToCategoryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToRoomTypesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToBoardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToPaymentCardsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToFeaturesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToImagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToHotelCodeEncryptResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToShortDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelToLongDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperHotelCategoryTypeResolver<TParent = any> {
  id?: JuniperHotelCategoryToIdResolver<TParent>;
  name?: JuniperHotelCategoryToNameResolver<TParent>;
}

export interface JuniperHotelCategoryToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelCategoryToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperHotelAddressTypeResolver<TParent = any> {
  address?: JuniperHotelAddressToAddressResolver<TParent>;
  city?: JuniperHotelAddressToCityResolver<TParent>;
  zip?: JuniperHotelAddressToZipResolver<TParent>;
  bookingEmail?: JuniperHotelAddressToBookingEmailResolver<TParent>;
  bookingFax?: JuniperHotelAddressToBookingFaxResolver<TParent>;
  bookingPhone?: JuniperHotelAddressToBookingPhoneResolver<TParent>;
  coordinates?: JuniperHotelAddressToCoordinatesResolver<TParent>;
}

export interface JuniperHotelAddressToAddressResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelAddressToCityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelAddressToZipResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelAddressToBookingEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelAddressToBookingFaxResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelAddressToBookingPhoneResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelAddressToCoordinatesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperCityTypeResolver<TParent = any> {
  code?: JuniperCityToCodeResolver<TParent>;
  name?: JuniperCityToNameResolver<TParent>;
}

export interface JuniperCityToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperCityToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperCoordinatesTypeResolver<TParent = any> {
  latitude?: JuniperCoordinatesToLatitudeResolver<TParent>;
  longitude?: JuniperCoordinatesToLongitudeResolver<TParent>;
}

export interface JuniperCoordinatesToLatitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperCoordinatesToLongitudeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperHotelRoomTypeResolver<TParent = any> {
  id?: JuniperHotelRoomToIdResolver<TParent>;
  occupancy?: JuniperHotelRoomToOccupancyResolver<TParent>;
  descriptions?: JuniperHotelRoomToDescriptionsResolver<TParent>;
  name?: JuniperHotelRoomToNameResolver<TParent>;
  max?: JuniperHotelRoomToMaxResolver<TParent>;
  addiFrom?: JuniperHotelRoomToAddiFromResolver<TParent>;
  childAsAdult?: JuniperHotelRoomToChildAsAdultResolver<TParent>;
  alter?: JuniperHotelRoomToAlterResolver<TParent>;
  roomTypeCategoryID?: JuniperHotelRoomToRoomTypeCategoryIDResolver<TParent>;
  roomTypeCategoryName?: JuniperHotelRoomToRoomTypeCategoryNameResolver<TParent>;
  nonRefundable?: JuniperHotelRoomToNonRefundableResolver<TParent>;
  infantAsChild?: JuniperHotelRoomToInfantAsChildResolver<TParent>;
}

export interface JuniperHotelRoomToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToOccupancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToDescriptionsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToMaxResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToAddiFromResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToChildAsAdultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToAlterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToRoomTypeCategoryIDResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToRoomTypeCategoryNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToNonRefundableResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperHotelRoomToInfantAsChildResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperOccupancyTypeResolver<TParent = any> {
  minChild?: JuniperOccupancyToMinChildResolver<TParent>;
  maxChild?: JuniperOccupancyToMaxChildResolver<TParent>;
  minAdult?: JuniperOccupancyToMinAdultResolver<TParent>;
  maxAdult?: JuniperOccupancyToMaxAdultResolver<TParent>;
}

export interface JuniperOccupancyToMinChildResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperOccupancyToMaxChildResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperOccupancyToMinAdultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperOccupancyToMaxAdultResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperDescriptionTypeResolver<TParent = any> {
  type?: JuniperDescriptionToTypeResolver<TParent>;
  text?: JuniperDescriptionToTextResolver<TParent>;
}

export interface JuniperDescriptionToTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperDescriptionToTextResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperBoardTypeResolver<TParent = any> {
  code?: JuniperBoardToCodeResolver<TParent>;
  name?: JuniperBoardToNameResolver<TParent>;
}

export interface JuniperBoardToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperBoardToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperPaymentCardTypeResolver<TParent = any> {
  code?: JuniperPaymentCardToCodeResolver<TParent>;
  name?: JuniperPaymentCardToNameResolver<TParent>;
}

export interface JuniperPaymentCardToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperPaymentCardToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperFeatureTypeResolver<TParent = any> {
  code?: JuniperFeatureToCodeResolver<TParent>;
  name?: JuniperFeatureToNameResolver<TParent>;
  payment?: JuniperFeatureToPaymentResolver<TParent>;
}

export interface JuniperFeatureToCodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperFeatureToNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperFeatureToPaymentResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLJuniperRoomCategoryTypeResolver<TParent = any> {
  roomTypeCategoryID?: JuniperRoomCategoryToRoomTypeCategoryIDResolver<TParent>;
  roomTypeCategoryName?: JuniperRoomCategoryToRoomTypeCategoryNameResolver<TParent>;
}

export interface JuniperRoomCategoryToRoomTypeCategoryIDResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface JuniperRoomCategoryToRoomTypeCategoryNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNewslettersTypeResolver<TParent = any> {
  list?: NewslettersToListResolver<TParent>;
}

export interface NewslettersToListArgs {
  verifiedOnly?: boolean;
}
export interface NewslettersToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: NewslettersToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLNewsletterTypeResolver<TParent = any> {
  id?: NewsletterToIdResolver<TParent>;
  email?: NewsletterToEmailResolver<TParent>;
  verified?: NewsletterToVerifiedResolver<TParent>;
  created?: NewsletterToCreatedResolver<TParent>;
  lastModified?: NewsletterToLastModifiedResolver<TParent>;
}

export interface NewsletterToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NewsletterToEmailResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NewsletterToVerifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NewsletterToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface NewsletterToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReferencesTypeResolver<TParent = any> {
  list?: ReferencesToListResolver<TParent>;
}

export interface ReferencesToListArgs {
  verifiedOnly?: boolean;
}
export interface ReferencesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: ReferencesToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLReferenceTypeResolver<TParent = any> {
  id?: ReferenceToIdResolver<TParent>;
  author?: ReferenceToAuthorResolver<TParent>;
  description?: ReferenceToDescriptionResolver<TParent>;
  state?: ReferenceToStateResolver<TParent>;
  created?: ReferenceToCreatedResolver<TParent>;
  lastModified?: ReferenceToLastModifiedResolver<TParent>;
}

export interface ReferenceToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceToAuthorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceToDescriptionResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceToStateResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceToCreatedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface ReferenceToLastModifiedResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRoutesTypeResolver<TParent = any> {
  get?: RoutesToGetResolver<TParent>;
}

export interface RoutesToGetArgs {
  slug: string;
}
export interface RoutesToGetResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RoutesToGetArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRouteResultTypeResolver<TParent = any> {
  (parent: TParent, context: any, info: GraphQLResolveInfo): 'Hotel' | 'Beach' | 'Area' | 'Destination' | 'Article';
}
export interface GQLPackagesTypeResolver<TParent = any> {
  list?: PackagesToListResolver<TParent>;
}

export interface PackagesToListArgs {
  first?: number;
  last?: number;
  after?: string;
  before?: string;
  selector?: GQLPackageSelector;
  sort?: GQLPackageSort;
  occupancyId?: string;
  not?: Array<string>;
}
export interface PackagesToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: PackagesToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSettingsTypeResolver<TParent = any> {
  list?: SettingsToListResolver<TParent>;
  socialNetworks?: SettingsToSocialNetworksResolver<TParent>;
}

export interface SettingsToListArgs {
  parameters?: Array<string>;
}
export interface SettingsToListResolver<TParent = any, TResult = any> {
  (parent: TParent, args: SettingsToListArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingsToSocialNetworksResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSettingTypeResolver<TParent = any> {
  parameterName?: SettingToParameterNameResolver<TParent>;
  parameterValue?: SettingToParameterValueResolver<TParent>;
}

export interface SettingToParameterNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SettingToParameterValueResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSocialNetworkTypeResolver<TParent = any> {
  network?: SocialNetworkToNetworkResolver<TParent>;
  url?: SocialNetworkToUrlResolver<TParent>;
}

export interface SocialNetworkToNetworkResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SocialNetworkToUrlResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSearchTypeResolver<TParent = any> {
  vacancy?: SearchToVacancyResolver<TParent>;
  hotel?: SearchToHotelResolver<TParent>;
}

export interface SearchToVacancyArgs {
  first: number;
  after?: string;
  selector: GQLSearchVacancyQuery;
  sort?: GQLSearchVacancySort;
}
export interface SearchToVacancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: SearchToVacancyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchToHotelArgs {
  first: number;
  after?: string;
  selector: GQLSearchHotelQuery;
}
export interface SearchToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: SearchToHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSearchVacancyConnectionTypeResolver<TParent = any> {
  edges?: SearchVacancyConnectionToEdgesResolver<TParent>;
  pageInfo?: SearchVacancyConnectionToPageInfoResolver<TParent>;
  totalCount?: SearchVacancyConnectionToTotalCountResolver<TParent>;
}

export interface SearchVacancyConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSearchVacancyEdgeTypeResolver<TParent = any> {
  node?: SearchVacancyEdgeToNodeResolver<TParent>;
  cursor?: SearchVacancyEdgeToCursorResolver<TParent>;
}

export interface SearchVacancyEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSearchVacancyTypeResolver<TParent = any> {
  id?: SearchVacancyToIdResolver<TParent>;
  hotel?: SearchVacancyToHotelResolver<TParent>;
  packageId?: SearchVacancyToPackageIdResolver<TParent>;
  boardName?: SearchVacancyToBoardNameResolver<TParent>;
  price?: SearchVacancyToPriceResolver<TParent>;
  numberOfNights?: SearchVacancyToNumberOfNightsResolver<TParent>;
}

export interface SearchVacancyToIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyToPackageIdResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyToBoardNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyToPriceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchVacancyToNumberOfNightsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSearchHotelConnectionTypeResolver<TParent = any> {
  edges?: SearchHotelConnectionToEdgesResolver<TParent>;
  pageInfo?: SearchHotelConnectionToPageInfoResolver<TParent>;
  totalCount?: SearchHotelConnectionToTotalCountResolver<TParent>;
}

export interface SearchHotelConnectionToEdgesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchHotelConnectionToPageInfoResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchHotelConnectionToTotalCountResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLSearchHotelEdgeTypeResolver<TParent = any> {
  node?: SearchHotelEdgeToNodeResolver<TParent>;
  cursor?: SearchHotelEdgeToCursorResolver<TParent>;
}

export interface SearchHotelEdgeToNodeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface SearchHotelEdgeToCursorResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUsersTypeResolver<TParent = any> {
  getCurrentLogin?: UsersToGetCurrentLoginResolver<TParent>;
  login?: UsersToLoginResolver<TParent>;
  refresh?: UsersToRefreshResolver<TParent>;
}

export interface UsersToGetCurrentLoginResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UsersToLoginArgs {
  username: string;
  password: string;
}
export interface UsersToLoginResolver<TParent = any, TResult = any> {
  (parent: TParent, args: UsersToLoginArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface UsersToRefreshResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLCurrentLoginTypeResolver<TParent = any> {
  expires?: CurrentLoginToExpiresResolver<TParent>;
  user?: CurrentLoginToUserResolver<TParent>;
}

export interface CurrentLoginToExpiresResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface CurrentLoginToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLUserTypeResolver<TParent = any> {
  username?: UserToUsernameResolver<TParent>;
}

export interface UserToUsernameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLLoginTypeResolver<TParent = any> {
  expires?: LoginToExpiresResolver<TParent>;
  token?: LoginToTokenResolver<TParent>;
  tokenName?: LoginToTokenNameResolver<TParent>;
  user?: LoginToUserResolver<TParent>;
}

export interface LoginToExpiresResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LoginToTokenResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LoginToTokenNameResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface LoginToUserResolver<TParent = any, TResult = any> {
  (parent: TParent, args: {}, context: any, info: GraphQLResolveInfo): TResult;
}

export interface GQLRootMutationTypeResolver<TParent = any> {
  createDestination?: RootMutationToCreateDestinationResolver<TParent>;
  updateDestination?: RootMutationToUpdateDestinationResolver<TParent>;
  deleteDestination?: RootMutationToDeleteDestinationResolver<TParent>;
  addDestinationSlug?: RootMutationToAddDestinationSlugResolver<TParent>;
  updateDestinationSlug?: RootMutationToUpdateDestinationSlugResolver<TParent>;
  deleteDestinationSlug?: RootMutationToDeleteDestinationSlugResolver<TParent>;
  addDestinationImage?: RootMutationToAddDestinationImageResolver<TParent>;
  updateDestinationImage?: RootMutationToUpdateDestinationImageResolver<TParent>;
  deleteDestinationImage?: RootMutationToDeleteDestinationImageResolver<TParent>;
  changeDestinationImageRank?: RootMutationToChangeDestinationImageRankResolver<TParent>;
  createArea?: RootMutationToCreateAreaResolver<TParent>;
  updateArea?: RootMutationToUpdateAreaResolver<TParent>;
  deleteArea?: RootMutationToDeleteAreaResolver<TParent>;
  addAreaSlug?: RootMutationToAddAreaSlugResolver<TParent>;
  updateAreaSlug?: RootMutationToUpdateAreaSlugResolver<TParent>;
  deleteAreaSlug?: RootMutationToDeleteAreaSlugResolver<TParent>;
  addAreaImage?: RootMutationToAddAreaImageResolver<TParent>;
  updateAreaImage?: RootMutationToUpdateAreaImageResolver<TParent>;
  deleteAreaImage?: RootMutationToDeleteAreaImageResolver<TParent>;
  changeAreaImageRank?: RootMutationToChangeAreaImageRankResolver<TParent>;
  createHotel?: RootMutationToCreateHotelResolver<TParent>;
  updateHotel?: RootMutationToUpdateHotelResolver<TParent>;
  deleteHotel?: RootMutationToDeleteHotelResolver<TParent>;
  addHotelSlug?: RootMutationToAddHotelSlugResolver<TParent>;
  updateHotelSlug?: RootMutationToUpdateHotelSlugResolver<TParent>;
  deleteHotelSlug?: RootMutationToDeleteHotelSlugResolver<TParent>;
  addHotelImage?: RootMutationToAddHotelImageResolver<TParent>;
  updateHotelImage?: RootMutationToUpdateHotelImageResolver<TParent>;
  deleteHotelImage?: RootMutationToDeleteHotelImageResolver<TParent>;
  changeHotelImageRank?: RootMutationToChangeHotelImageRankResolver<TParent>;
  setHotelPromoPackage?: RootMutationToSetHotelPromoPackageResolver<TParent>;
  unsetHotelPromoPackage?: RootMutationToUnsetHotelPromoPackageResolver<TParent>;
  createRoom?: RootMutationToCreateRoomResolver<TParent>;
  updateRoom?: RootMutationToUpdateRoomResolver<TParent>;
  deleteRoom?: RootMutationToDeleteRoomResolver<TParent>;
  addRoomImage?: RootMutationToAddRoomImageResolver<TParent>;
  updateRoomImage?: RootMutationToUpdateRoomImageResolver<TParent>;
  deleteRoomImage?: RootMutationToDeleteRoomImageResolver<TParent>;
  changeRoomImageRank?: RootMutationToChangeRoomImageRankResolver<TParent>;
  createOccupancy?: RootMutationToCreateOccupancyResolver<TParent>;
  updateOccupancy?: RootMutationToUpdateOccupancyResolver<TParent>;
  deleteOccupancy?: RootMutationToDeleteOccupancyResolver<TParent>;
  createBeach?: RootMutationToCreateBeachResolver<TParent>;
  updateBeach?: RootMutationToUpdateBeachResolver<TParent>;
  deleteBeach?: RootMutationToDeleteBeachResolver<TParent>;
  addBeachSlug?: RootMutationToAddBeachSlugResolver<TParent>;
  updateBeachSlug?: RootMutationToUpdateBeachSlugResolver<TParent>;
  deleteBeachSlug?: RootMutationToDeleteBeachSlugResolver<TParent>;
  addBeachImage?: RootMutationToAddBeachImageResolver<TParent>;
  updateBeachImage?: RootMutationToUpdateBeachImageResolver<TParent>;
  deleteBeachImage?: RootMutationToDeleteBeachImageResolver<TParent>;
  changeBeachImageRank?: RootMutationToChangeBeachImageRankResolver<TParent>;
  createPackage?: RootMutationToCreatePackageResolver<TParent>;
  updatePackage?: RootMutationToUpdatePackageResolver<TParent>;
  deletePackage?: RootMutationToDeletePackageResolver<TParent>;
  relateBeachToHotel?: RootMutationToRelateBeachToHotelResolver<TParent>;
  unrelateBeachFromHotel?: RootMutationToUnrelateBeachFromHotelResolver<TParent>;
  updateHotelBeach?: RootMutationToUpdateHotelBeachResolver<TParent>;
  relateTagToHotel?: RootMutationToRelateTagToHotelResolver<TParent>;
  unrelateTagFromHotel?: RootMutationToUnrelateTagFromHotelResolver<TParent>;
  relateEventToHotel?: RootMutationToRelateEventToHotelResolver<TParent>;
  unrelateEventFromHotel?: RootMutationToUnrelateEventFromHotelResolver<TParent>;
  relateActivityToHotel?: RootMutationToRelateActivityToHotelResolver<TParent>;
  unrelateActivityFromHotel?: RootMutationToUnrelateActivityFromHotelResolver<TParent>;
  createHotelReview?: RootMutationToCreateHotelReviewResolver<TParent>;
  updateHotelReview?: RootMutationToUpdateHotelReviewResolver<TParent>;
  deleteHotelReview?: RootMutationToDeleteHotelReviewResolver<TParent>;
  createTag?: RootMutationToCreateTagResolver<TParent>;
  updateTag?: RootMutationToUpdateTagResolver<TParent>;
  deleteTag?: RootMutationToDeleteTagResolver<TParent>;
  createBoard?: RootMutationToCreateBoardResolver<TParent>;
  updateBoard?: RootMutationToUpdateBoardResolver<TParent>;
  deleteBoard?: RootMutationToDeleteBoardResolver<TParent>;
  createCurrency?: RootMutationToCreateCurrencyResolver<TParent>;
  updateCurrency?: RootMutationToUpdateCurrencyResolver<TParent>;
  deleteCurrency?: RootMutationToDeleteCurrencyResolver<TParent>;
  createEvent?: RootMutationToCreateEventResolver<TParent>;
  updateEvent?: RootMutationToUpdateEventResolver<TParent>;
  deleteEvent?: RootMutationToDeleteEventResolver<TParent>;
  createHotelType?: RootMutationToCreateHotelTypeResolver<TParent>;
  updateHotelType?: RootMutationToUpdateHotelTypeResolver<TParent>;
  deleteHotelType?: RootMutationToDeleteHotelTypeResolver<TParent>;
  createActivity?: RootMutationToCreateActivityResolver<TParent>;
  updateActivity?: RootMutationToUpdateActivityResolver<TParent>;
  deleteActivity?: RootMutationToDeleteActivityResolver<TParent>;
  addActivityImage?: RootMutationToAddActivityImageResolver<TParent>;
  updateActivityImage?: RootMutationToUpdateActivityImageResolver<TParent>;
  createReference?: RootMutationToCreateReferenceResolver<TParent>;
  updateReference?: RootMutationToUpdateReferenceResolver<TParent>;
  deleteReference?: RootMutationToDeleteReferenceResolver<TParent>;
  registerNewsletter?: RootMutationToRegisterNewsletterResolver<TParent>;
  verifyNewsletter?: RootMutationToVerifyNewsletterResolver<TParent>;
  removeNewsletter?: RootMutationToRemoveNewsletterResolver<TParent>;
  createArticle?: RootMutationToCreateArticleResolver<TParent>;
  updateArticle?: RootMutationToUpdateArticleResolver<TParent>;
  deleteArticle?: RootMutationToDeleteArticleResolver<TParent>;
  addArticleSlug?: RootMutationToAddArticleSlugResolver<TParent>;
  updateArticleSlug?: RootMutationToUpdateArticleSlugResolver<TParent>;
  deleteArticleSlug?: RootMutationToDeleteArticleSlugResolver<TParent>;
  addArticleImage?: RootMutationToAddArticleImageResolver<TParent>;
  updateArticleImage?: RootMutationToUpdateArticleImageResolver<TParent>;
  changeArticleImageRank?: RootMutationToChangeArticleImageRankResolver<TParent>;
  deleteArticleImage?: RootMutationToDeleteArticleImageResolver<TParent>;
  deleteArticleRelation?: RootMutationToDeleteArticleRelationResolver<TParent>;
  importElixirHotel?: RootMutationToImportElixirHotelResolver<TParent>;
  importElixirPackages?: RootMutationToImportElixirPackagesResolver<TParent>;
  importJuniperHotel?: RootMutationToImportJuniperHotelResolver<TParent>;
  importJuniperOccupancy?: RootMutationToImportJuniperOccupancyResolver<TParent>;
  saveSettings?: RootMutationToSaveSettingsResolver<TParent>;
  deleteSettings?: RootMutationToDeleteSettingsResolver<TParent>;
  inquiry?: RootMutationToInquiryResolver<TParent>;
  tailoredOffer?: RootMutationToTailoredOfferResolver<TParent>;
  contact?: RootMutationToContactResolver<TParent>;
}

export interface RootMutationToCreateDestinationArgs {
  input: GQLDestinationCreate;
}
export interface RootMutationToCreateDestinationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateDestinationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateDestinationArgs {
  input: GQLDestinationUpdate;
  id: string;
}
export interface RootMutationToUpdateDestinationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateDestinationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteDestinationArgs {
  id: string;
}
export interface RootMutationToDeleteDestinationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteDestinationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddDestinationSlugArgs {
  input: GQLSlugCreate;
}
export interface RootMutationToAddDestinationSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddDestinationSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateDestinationSlugArgs {
  input: GQLSlugUpdate;
  id: string;
}
export interface RootMutationToUpdateDestinationSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateDestinationSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteDestinationSlugArgs {
  id: string;
}
export interface RootMutationToDeleteDestinationSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteDestinationSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddDestinationImageArgs {
  input: GQLImageCreate;
  destinationId: string;
  imageType: GQLImageType;
}
export interface RootMutationToAddDestinationImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddDestinationImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateDestinationImageArgs {
  input: GQLImageUpdate;
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToUpdateDestinationImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateDestinationImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteDestinationImageArgs {
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToDeleteDestinationImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteDestinationImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToChangeDestinationImageRankArgs {
  movedImageId: string;
  relativeImageId: string;
  after: boolean;
}
export interface RootMutationToChangeDestinationImageRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToChangeDestinationImageRankArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateAreaArgs {
  input: GQLAreaCreate;
}
export interface RootMutationToCreateAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateAreaArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateAreaArgs {
  input: GQLAreaUpdate;
  id: string;
}
export interface RootMutationToUpdateAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateAreaArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteAreaArgs {
  id: string;
}
export interface RootMutationToDeleteAreaResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteAreaArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddAreaSlugArgs {
  input: GQLSlugCreate;
}
export interface RootMutationToAddAreaSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddAreaSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateAreaSlugArgs {
  input: GQLSlugUpdate;
  id: string;
}
export interface RootMutationToUpdateAreaSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateAreaSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteAreaSlugArgs {
  id: string;
}
export interface RootMutationToDeleteAreaSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteAreaSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddAreaImageArgs {
  input: GQLImageCreate;
  areaId: string;
  imageType: GQLImageType;
}
export interface RootMutationToAddAreaImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddAreaImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateAreaImageArgs {
  input: GQLImageUpdate;
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToUpdateAreaImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateAreaImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteAreaImageArgs {
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToDeleteAreaImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteAreaImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToChangeAreaImageRankArgs {
  movedImageId: string;
  relativeImageId: string;
  after: boolean;
}
export interface RootMutationToChangeAreaImageRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToChangeAreaImageRankArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateHotelArgs {
  input: GQLHotelCreate;
}
export interface RootMutationToCreateHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateHotelArgs {
  input: GQLHotelUpdate;
  id: string;
}
export interface RootMutationToUpdateHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteHotelArgs {
  id: string;
}
export interface RootMutationToDeleteHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddHotelSlugArgs {
  input: GQLSlugCreate;
}
export interface RootMutationToAddHotelSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddHotelSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateHotelSlugArgs {
  input: GQLSlugUpdate;
  id: string;
}
export interface RootMutationToUpdateHotelSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateHotelSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteHotelSlugArgs {
  id: string;
}
export interface RootMutationToDeleteHotelSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteHotelSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddHotelImageArgs {
  input: GQLImageCreate;
  hotelId: string;
  imageType: GQLImageType;
}
export interface RootMutationToAddHotelImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddHotelImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateHotelImageArgs {
  input: GQLImageUpdate;
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToUpdateHotelImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateHotelImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteHotelImageArgs {
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToDeleteHotelImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteHotelImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToChangeHotelImageRankArgs {
  movedImageId: string;
  relativeImageId: string;
  after: boolean;
}
export interface RootMutationToChangeHotelImageRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToChangeHotelImageRankArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToSetHotelPromoPackageArgs {
  hotelId: string;
  packageId: string;
}
export interface RootMutationToSetHotelPromoPackageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToSetHotelPromoPackageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUnsetHotelPromoPackageArgs {
  hotelId: string;
  packageId: string;
}
export interface RootMutationToUnsetHotelPromoPackageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUnsetHotelPromoPackageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateRoomArgs {
  input: GQLRoomCreate;
}
export interface RootMutationToCreateRoomResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateRoomArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateRoomArgs {
  input: GQLRoomUpdate;
  id: string;
}
export interface RootMutationToUpdateRoomResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateRoomArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteRoomArgs {
  id: string;
}
export interface RootMutationToDeleteRoomResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteRoomArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddRoomImageArgs {
  input: GQLImageCreate;
  roomId: string;
  imageType: GQLImageType;
}
export interface RootMutationToAddRoomImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddRoomImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateRoomImageArgs {
  input: GQLImageUpdate;
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToUpdateRoomImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateRoomImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteRoomImageArgs {
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToDeleteRoomImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteRoomImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToChangeRoomImageRankArgs {
  movedImageId: string;
  relativeImageId: string;
  after: boolean;
}
export interface RootMutationToChangeRoomImageRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToChangeRoomImageRankArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateOccupancyArgs {
  input: GQLCreateOccupancy;
}
export interface RootMutationToCreateOccupancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateOccupancyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateOccupancyArgs {
  input: GQLUpdateOccupancy;
  id: string;
}
export interface RootMutationToUpdateOccupancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateOccupancyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteOccupancyArgs {
  id: string;
}
export interface RootMutationToDeleteOccupancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteOccupancyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateBeachArgs {
  input: GQLBeachCreate;
}
export interface RootMutationToCreateBeachResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateBeachArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateBeachArgs {
  input: GQLBeachUpdate;
  id: string;
}
export interface RootMutationToUpdateBeachResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateBeachArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteBeachArgs {
  id: string;
}
export interface RootMutationToDeleteBeachResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteBeachArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddBeachSlugArgs {
  input: GQLSlugCreate;
}
export interface RootMutationToAddBeachSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddBeachSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateBeachSlugArgs {
  input: GQLSlugUpdate;
  id: string;
}
export interface RootMutationToUpdateBeachSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateBeachSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteBeachSlugArgs {
  id: string;
}
export interface RootMutationToDeleteBeachSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteBeachSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddBeachImageArgs {
  input: GQLImageCreate;
  beachId: string;
  imageType: GQLImageType;
}
export interface RootMutationToAddBeachImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddBeachImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateBeachImageArgs {
  input: GQLImageUpdate;
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToUpdateBeachImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateBeachImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteBeachImageArgs {
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToDeleteBeachImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteBeachImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToChangeBeachImageRankArgs {
  movedImageId: string;
  relativeImageId: string;
  after: boolean;
}
export interface RootMutationToChangeBeachImageRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToChangeBeachImageRankArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreatePackageArgs {
  input: GQLPackageCreate;
}
export interface RootMutationToCreatePackageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreatePackageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdatePackageArgs {
  input: GQLPackageUpdate;
  id: string;
}
export interface RootMutationToUpdatePackageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdatePackageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeletePackageArgs {
  id: string;
}
export interface RootMutationToDeletePackageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeletePackageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToRelateBeachToHotelArgs {
  beachId: string;
  hotelId: string;
  nextToHotel: boolean;
}
export interface RootMutationToRelateBeachToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToRelateBeachToHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUnrelateBeachFromHotelArgs {
  hotelId: string;
  beachId: string;
}
export interface RootMutationToUnrelateBeachFromHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUnrelateBeachFromHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateHotelBeachArgs {
  beachId: string;
  hotelId: string;
  nextToHotel: boolean;
}
export interface RootMutationToUpdateHotelBeachResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateHotelBeachArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToRelateTagToHotelArgs {
  tagId: string;
  hotelId: string;
}
export interface RootMutationToRelateTagToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToRelateTagToHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUnrelateTagFromHotelArgs {
  tagId: string;
  hotelId: string;
}
export interface RootMutationToUnrelateTagFromHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUnrelateTagFromHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToRelateEventToHotelArgs {
  eventId: string;
  hotelId: string;
}
export interface RootMutationToRelateEventToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToRelateEventToHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUnrelateEventFromHotelArgs {
  eventId: string;
  hotelId: string;
}
export interface RootMutationToUnrelateEventFromHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUnrelateEventFromHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToRelateActivityToHotelArgs {
  activityId: string;
  hotelId: string;
}
export interface RootMutationToRelateActivityToHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToRelateActivityToHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUnrelateActivityFromHotelArgs {
  activityId: string;
  hotelId: string;
}
export interface RootMutationToUnrelateActivityFromHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUnrelateActivityFromHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateHotelReviewArgs {
  input: GQLHotelReviewCreate;
  hotelId: string;
}
export interface RootMutationToCreateHotelReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateHotelReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateHotelReviewArgs {
  input: GQLHotelReviewUpdate;
  id: string;
}
export interface RootMutationToUpdateHotelReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateHotelReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteHotelReviewArgs {
  id: string;
}
export interface RootMutationToDeleteHotelReviewResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteHotelReviewArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateTagArgs {
  input: GQLTagCreate;
}
export interface RootMutationToCreateTagResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateTagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateTagArgs {
  input: GQLTagUpdate;
  id: string;
}
export interface RootMutationToUpdateTagResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateTagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteTagArgs {
  id: string;
}
export interface RootMutationToDeleteTagResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteTagArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateBoardArgs {
  input: GQLBoardCreate;
}
export interface RootMutationToCreateBoardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateBoardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateBoardArgs {
  input: GQLBoardUpdate;
  id: string;
}
export interface RootMutationToUpdateBoardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateBoardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteBoardArgs {
  id: string;
}
export interface RootMutationToDeleteBoardResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteBoardArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateCurrencyArgs {
  input: GQLCurrencyCreate;
}
export interface RootMutationToCreateCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateCurrencyArgs {
  input: GQLCurrencyUpdate;
  id: string;
}
export interface RootMutationToUpdateCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteCurrencyArgs {
  id: string;
}
export interface RootMutationToDeleteCurrencyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteCurrencyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateEventArgs {
  input: GQLEventCreate;
}
export interface RootMutationToCreateEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateEventArgs {
  input: GQLEventUpdate;
  id: string;
}
export interface RootMutationToUpdateEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteEventArgs {
  id: string;
}
export interface RootMutationToDeleteEventResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteEventArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateHotelTypeArgs {
  input: GQLHotelTypeCreate;
}
export interface RootMutationToCreateHotelTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateHotelTypeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateHotelTypeArgs {
  input: GQLHotelTypeUpdate;
  id: string;
}
export interface RootMutationToUpdateHotelTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateHotelTypeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteHotelTypeArgs {
  id: string;
}
export interface RootMutationToDeleteHotelTypeResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteHotelTypeArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateActivityArgs {
  input: GQLActivityCreate;
}
export interface RootMutationToCreateActivityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateActivityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateActivityArgs {
  input: GQLActivityUpdate;
  id: string;
}
export interface RootMutationToUpdateActivityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateActivityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteActivityArgs {
  id: string;
}
export interface RootMutationToDeleteActivityResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteActivityArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddActivityImageArgs {
  input: GQLImageCreate;
  activityId: string;
}
export interface RootMutationToAddActivityImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddActivityImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateActivityImageArgs {
  input: GQLImageUpdate;
  id: string;
}
export interface RootMutationToUpdateActivityImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateActivityImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateReferenceArgs {
  input: GQLReferenceCreate;
}
export interface RootMutationToCreateReferenceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateReferenceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateReferenceArgs {
  input: GQLReferenceUpdate;
  id: string;
}
export interface RootMutationToUpdateReferenceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateReferenceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteReferenceArgs {
  id: string;
}
export interface RootMutationToDeleteReferenceResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteReferenceArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToRegisterNewsletterArgs {
  email: string;
}
export interface RootMutationToRegisterNewsletterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToRegisterNewsletterArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToVerifyNewsletterArgs {
  verifyToken: string;
}
export interface RootMutationToVerifyNewsletterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToVerifyNewsletterArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToRemoveNewsletterArgs {
  email: string;
}
export interface RootMutationToRemoveNewsletterResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToRemoveNewsletterArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToCreateArticleArgs {
  input: GQLArticleCreate;
}
export interface RootMutationToCreateArticleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToCreateArticleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateArticleArgs {
  input: GQLArticleUpdate;
  id: string;
}
export interface RootMutationToUpdateArticleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateArticleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteArticleArgs {
  id: string;
}
export interface RootMutationToDeleteArticleResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteArticleArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddArticleSlugArgs {
  input: GQLSlugCreate;
}
export interface RootMutationToAddArticleSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddArticleSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateArticleSlugArgs {
  input: GQLSlugUpdate;
  id: string;
}
export interface RootMutationToUpdateArticleSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateArticleSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteArticleSlugArgs {
  id: string;
}
export interface RootMutationToDeleteArticleSlugResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteArticleSlugArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToAddArticleImageArgs {
  input: GQLImageCreate;
  articleId: string;
  imageType: GQLImageType;
}
export interface RootMutationToAddArticleImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToAddArticleImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToUpdateArticleImageArgs {
  input: GQLImageUpdate;
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToUpdateArticleImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToUpdateArticleImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToChangeArticleImageRankArgs {
  movedImageId: string;
  relativeImageId: string;
  after: boolean;
}
export interface RootMutationToChangeArticleImageRankResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToChangeArticleImageRankArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteArticleImageArgs {
  id: string;
  imageType: GQLImageType;
}
export interface RootMutationToDeleteArticleImageResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteArticleImageArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteArticleRelationArgs {
  articleId: string;
  hotelId?: string;
  destinationId?: string;
}
export interface RootMutationToDeleteArticleRelationResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteArticleRelationArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToImportElixirHotelArgs {
  id: number;
  areaId: string;
  hotelTypeId: string;
}
export interface RootMutationToImportElixirHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToImportElixirHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToImportElixirPackagesArgs {
  hotelId?: number;
  roomId?: number;
  occupancyId: string;
}
export interface RootMutationToImportElixirPackagesResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToImportElixirPackagesArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToImportJuniperHotelArgs {
  id: string;
  areaId: string;
  hotelTypeId: string;
}
export interface RootMutationToImportJuniperHotelResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToImportJuniperHotelArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToImportJuniperOccupancyArgs {
  hotelCode: string;
  roomCategoryId: number;
  roomId: string;
}
export interface RootMutationToImportJuniperOccupancyResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToImportJuniperOccupancyArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToSaveSettingsArgs {
  parameters?: Array<GQLSaveSetting>;
  defined?: GQLDefinedSetting;
}
export interface RootMutationToSaveSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToSaveSettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToDeleteSettingsArgs {
  parameters: Array<string>;
}
export interface RootMutationToDeleteSettingsResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToDeleteSettingsArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToInquiryArgs {
  input: GQLInquiry;
}
export interface RootMutationToInquiryResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToInquiryArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToTailoredOfferArgs {
  input: GQLTailoredOffer;
}
export interface RootMutationToTailoredOfferResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToTailoredOfferArgs, context: any, info: GraphQLResolveInfo): TResult;
}

export interface RootMutationToContactArgs {
  input: GQLContact;
}
export interface RootMutationToContactResolver<TParent = any, TResult = any> {
  (parent: TParent, args: RootMutationToContactArgs, context: any, info: GraphQLResolveInfo): TResult;
}
